const he = {
  appTitle: 'אני גיבור',
  appSubtitle: 'סיפורים אישיים לילדים — כי כל ילד הוא גיבור',

  // Zone 1 — Hero identity
  zone1Title: 'ספרו לנו על הגיבור/ה',
  name: 'שם הילד/ה',
  namePlaceholder: 'נועה',
  age: 'גיל',
  agePlaceholder: '5',
  genderFemale: 'בת',
  genderMale: 'בן',

  // Story language toggle
  storyLanguageLabel: 'שפת הסיפור',
  storyLanguageFos7a: 'עברית ספרותית',
  storyLanguageLahja: 'עברית מדוברת',
  storyLanguageEnglish: 'אנגלית',
  storyLanguageHelper: 'עברית ספרותית לקריאה חינוכית, או עברית מדוברת ויומיומית.',

  // Imagery type selector
  imageStyleLabel: 'סגנון איורים',
  imageStyleHelper: 'איך תרצו שהסיפור ייראה?',
  imageStyleOptions: [
    { value: 'pixar', label: 'דיסני 3D' },
    { value: 'anime', label: 'אנימה' },
  ],

  // Story line selector
  storyLineLabel: 'סוג הסיפור',
  storyLineFears: 'סיפור טיפולי (התמודדות עם פחדים)',
  storyLineImaginary: 'סיפור דמיוני',
  storyLineHero: 'סיפור גבורה',
  storyLineHelper: 'בחרו את סוג הסיפור שמתאים לילדכם.',

  // Zone 2 — Therapeutic core
  zone2Title: 'מה ילדכם חווה?',
  issue: 'ספרו לנו מה קורה עם ילדכם',
  issuePlaceholder: 'לדוגמה: הבת שלי בת 4, כל פעם שאני לוקחת אותה לגן היא מתחילה לבכות ולא נותנת לי ללכת...',
  issueHelper: 'ככל שתספרו יותר, הסיפור יהיה קרוב יותר לילדכם 💛',
  whenHappens: 'מתי זה קורה בעיקר?',
  whenHappensPlaceholder: 'בזמן שינה, לפני הגן, כשהוא/היא רחוק/ה ממני...',
  howBehaves: 'איך הוא/היא מתנהג/ת כשזה קורה?',
  howBehavesPlaceholder: 'בוכה, צורח/ת, מתבודד/ת, מסרב/ת לדבר...',
  smallGoal: 'אם הסיפור יעזור בדבר אחד קטן, מה תרצו?',
  smallGoalPlaceholder: 'שיוכל לישון לבד, שתלך לגן בלי בכי...',
  smallGoalHelper: 'לא חייב להיות יעד גדול — צעד קטן מספיק ☺',

  // New therapeutic detail fields
  familyStructure: 'מבנה המשפחה',
  familyStructureSelectPlaceholder: 'בחרו מבנה משפחה',
  familyStructureOptions: [
    'אבא ואמא',
    'משפחה עם ילדים',
    'אם חד-הורית',
    'אב חד-הורי',
    'משפחה מורחבת (סבא/סבתא)',
    'הורים מאמצים',
    'גר/ה עם קרובים',
    'אחר',
  ],
  personalityTraits: 'תכונות אישיות של ילדכם',
  personalityTraitOptions: [
    'פעיל/ה',
    'סקרן/ית',
    'חכם/ה',
    'חברותי/ת',
    'ביישן/ית',
    'עקשן/ית',
    'רגיש/ה',
    'שקט/ה',
    'שמח/ה',
    'חנון/ה',
    'עצמאי/ת',
    'מדויק/ת',
  ],
  personalityTraitsAddCustom: 'הוסיפו תכונה שלא ברשימה…',
  personalityTraitsAddBtn: 'הוספה',

  // Zone 3 — Optional extras
  zone3Toggle: 'פרטים נוספים שישדרגו את הסיפור ✨',
  interests: 'מה ילדכם אוהב/ת?',
  interestsPlaceholder: 'דינוזאורים, ציור, מכוניות, חתולים...',
  interestsHelper: 'נשלב את התחביבים בסיפור כדי שירגיש אישי',
  environment: 'איפה אתם גרים?',
  environmentPlaceholder: 'בית עם גינה, דירה בעיר...',
  environmentHelper: 'עוזר לנו להתאים את אווירת הסיפור',
  photos: 'תמונות של ילדכם',
  photosHint: 'עד 5 תמונות — נשתמש בהן ליצירת האיורים',
  referenceUrls: 'קישורים לתמונות הפניה',
  referenceUrlsPlaceholder: 'https://i.imgur.com/abc.png, https://example.com/ref.jpg',
  referenceUrlsHelper: 'קישורים לתמונות ייחוס לדמות (הפרידו בפסיקים). עובד עם Midjourney ו-Seedream.',

  // CTA
  submitWithName: 'צרו את הסיפור של ',
  submitGeneric: 'צרו את הסיפור ✨',

  // Loader
  loading1: 'בונים סיפור מיוחד…',
  loading2: 'כותבים את העלילה…',
  loading3: 'בודקים כל פרט…',
  loading4: 'מלטשים את הלשון…',
  loading5: 'מציירים את הסצנות…',

  // Other
  again: 'צרו סיפור חדש',
  errorTitle: 'אירעה שגיאה',

  // Book viewer
  nextPage: 'העמוד הבא',
  prevPage: 'העמוד הקודם',
  bookStateClosedFront: 'הספר סגור · כריכה קדמית',
  bookStateOpen: 'הספר פתוח · עמוד כפול',
  bookStateClosedBack: 'הספר סגור · כריכה אחורית',
  downloadPdf: 'הורדת הסיפור PDF 📕',
  downloadingPdf: 'מכין…',

  // ── Storefront ──
  home: 'דף הבית',
  shopAll: 'כל הסיפורים',
  navStories: 'סיפורים',
  navTherapy: 'סיפורים טיפוליים',
  navBirthday: 'סיפורי דמיון',
  navHeroes: 'סיפורי גיבורים',
  navMilestones: 'צעדים גדולים',
  navBlog: 'בלוג',
  heroHeadline: 'ילדכם הגיבור של הסיפור',
  heroSubline: 'ספר ילדים מאויר ואישי, שנכתב וצויר במיוחד לילדכם',
  featureHero: 'ילדכם הוא הגיבור',
  featureHeroDesc: 'סיפור ייחודי על שמו ומותאם אליו',
  featureIllustrations: 'איורים מקוריים',
  featureIllustrationsDesc: 'כל סצנה מצוירת במיוחד עבור ילדכם',
  featureTherapy: 'תוכן טיפולי',
  featureTherapyDesc: 'עוזר לילדכם להתמודד עם אתגרים',
  sampleStories: 'דוגמאות מהסיפורים שלנו',
  sampleTherapy: 'שרה והכלב החברותי',
  sampleTherapyDesc: 'סיפור טיפולי שעוזר להתגבר על פחד מכלבים',
  sampleBirthday: 'יוסי ומלכות כוכב הדינוזאורים',
  sampleBirthdayDesc: 'סיפור יום הולדת — יוסי יוצא להרפתקה בחלל',
  sampleHeroes: 'גלימת האומץ הקסומה',
  sampleHeroesDesc: 'סיפור גבורה — אדם מגלה את כוחות-העל שבו',
  viewPdf: 'לקריאת הסיפור ←',
  featuredTemplates: 'הסיפורים הפופולריים',
  browseCategories: 'סיפורים לפי קטגוריה',
  viewAll: 'הצג הכל',
  createYourStory: 'צרו את הסיפור שלכם',
  startCreating: 'התחילו עכשיו',
  from: 'החל מ',
  currency: ' ₪',
  ageBandLabel: 'טווח גילאים',
  templateNotFound: 'התבנית לא נמצאה',
  categoryNotFound: 'הקטגוריה לא נמצאה',
  previewFailed: 'משהו השתבש ולא הצלחנו ליצור את הסיפור. נסו שוב.',
  tryAgain: 'נסו שוב',
  backToHome: 'דף הבית',
  back: 'חזרה',
  noTemplatesInCategory: 'אין סיפורים בקטגוריה זו כרגע',

  // Variant types
  softcover: 'כריכה רכה',
  hardcover: 'כריכה קשה (כולל PDF)',
  digital: 'עותק דיגיטלי PDF',

  // Imagination topic picker
  topicOther: 'נושא אחר',
  topicOtherEmoji: '✏️',
  topicOtherPlaceholder: 'כתבו את רעיון הסיפור… לדוגמה: הילד שלי גיבור-על שעף מעל חיפה ומציל את חבריו',
  topicRequired: 'בחרו נושא לסיפור, או לחצו על «נושא אחר» וכתבו את הרעיון שלכם',
  // Toggle fields (מין) open with nothing selected, so the parent must answer
  // them; these two lines are the nudge and the blocking error.
  toggleChooseHint: 'עדיין לא נבחר',
  toggleRequiredPrefix: 'יש לבחור:',
  freePreviewLimitTitle: 'התצוגה המקדימה החינמית הסתיימה',
  freePreviewLimitBody: 'כדי להשלים את הסיפור, הזמינו אותו עכשיו. לאחר ההזמנה תוכלו לבקש עריכות, הצוות שלנו ישלים את הסיפור, ולא נדפיס ונשלח עד שתאשרו את הגרסה הסופית.',
  freePreviewLimitOrderCta: 'הזמינו את הסיפור עכשיו',
  freePreviewLimitContactPrefix: 'יש שאלה?',
  freePreviewLimitContactLink: 'דברו איתנו בוואטסאפ',
  topicChange: 'שינוי נושא',

  // Create page
  createTitle: 'התאימו את הסיפור',
  requiredField: 'שדה חובה',
  generatePreview: 'תצוגה מקדימה',
  generatingPreview: 'מכין…',
  addToCart: 'הוספה לסל',
  characterImageLabel: 'תמונת הגיבור/ה',
  characterImageHelp: 'העלו תמונה אחת של הגיבור/ה כדי שיופיע/תופיע עם אותם תווי פנים בכל הסצנות.',
  referenceImagesLabel: 'תמונות ייחוס נוספות',
  referenceImagesHelp: 'ניתן להעלות עד 10 תמונות (מקום, חיית מחמד, דמויות נוספות…) שיופיעו בסיפור.',
  referenceDescriptionPlaceholder: 'דוגמה: חבר שלו שמעון / סבא שלו / החתולה האפורה שלו',
  referenceDescriptionHelp: 'כתבו מתחת לכל תמונה מי או מה זה — נשתמש בתיאור כדי לשלב את הדמות או הפריט בסצנות המתאימות.',
  removeImage: 'הסרה',

  noPhotoTitle: 'רגע! לא הוספתם תמונה של ילדכם',
  noPhotoMessage: 'כשילדכם רואה את עצמו כגיבור הסיפור, הסיפור נהיה קרוב ללב ומשפיע הרבה יותר. לכן אנחנו ממליצים להעלות תמונה. אם מעדיפים לא להעלות, אפשר לתאר את המראה במילים ואנחנו ניצור דמות דומה.',
  noPhotoUploadLabel: 'העלו תמונה עכשיו',
  noPhotoOr: 'או',
  noPhotoDescribeLabel: 'תארו את המראה במילים',
  noPhotoDescribePlaceholder: 'לדוגמה: שיער שחור קצר ומתולתל, עיניים חומות, עור שזוף, לובש חולצה כחולה…',
  noPhotoDescribeHelp: 'ככל שהתיאור מפורט יותר, הדמות תהיה דומה יותר לילדכם.',
  noPhotoContinue: 'המשך',
  noPhotoContinueAnyway: 'המשך בלי תמונה',
  noPhotoClose: 'סגור',

  heroRecapLabel: 'הסיפור עבור',
  heroRecapEdit: 'עריכה',
  ageUnitOne: 'שנה',
  ageUnitTwo: 'שנתיים',
  ageUnitFew: 'שנים',
  ageUnitMany: 'שנים',
  contactStepTitle: 'עוד צעד אחד לפני התצוגה המקדימה',
  contactStepSubtitle: 'השאירו פרטים כדי שנוכל לשלוח לכם את התצוגה המקדימה וליצור אתכם קשר.',
  contactNameLabel: 'שם מלא',
  contactEmailLabel: 'דוא"ל',
  contactPhoneLabel: 'מספר טלפון (וואטסאפ)',
  contactPhoneHelper: 'ניצור קשר דרך וואטסאפ בעת הצורך.',
  contactContinue: 'המשיכו לתצוגה מקדימה',
  contactBack: 'חזרה',
  contactErrorRequired: 'יש למלא שם, דוא"ל ומספר טלפון.',
  contactErrorEmail: 'כתובת דוא"ל לא תקינה.',
  contactErrorPhone: 'מספר טלפון לא תקין.',

  adminForCustomerToggle: 'יצירת תצוגה מקדימה ללקוח (הזמנה ידנית)',
  adminForCustomerOn: 'מצב לקוח פעיל: פרטי הלקוח יישמרו ותיווצר הזמנה אמיתית שניתן לנהל בלוח ההזמנות.',
  adminForCustomerOff: 'הפעל/י אפשרות זו כדי ליצור תצוגה מקדימה בשם לקוח (למשל הזמנה דרך וואטסאפ שמשולמת מחוץ לאתר).',
  adminCustomerStepTitle: 'פרטי הלקוח',
  adminCustomerStepSubtitle: 'הזן/י שם, דוא"ל ומספר טלפון של הלקוח. ניצור לו/לה חשבון והזמנה שניתן לעדכן מאוחר יותר.',

  dropzonePrimary: 'גררו תמונות לכאן או לחצו לבחירה',
  dropzoneDropNow: 'שחררו את התמונות כאן',
  dropzoneHintSingle: 'תמונה אחת • PNG או JPG',
  dropzoneHintMulti: 'עד {n} תמונות • PNG או JPG',

  photoGuideAlt: 'דוגמה שמראה איך לצלם את הילד/ה: תמונה קרובה וברורה של הפנים, ותמונות שכדאי להימנע מהן',
  photoGuideZoom: 'הגדלת הדוגמה',
  photoGuideClose: 'סגור',

  photoHelpTitle: 'לפני שמעלים את התמונה',
  photoHelpText: 'דקה אחת וגיבור הסיפור יידמה לילד/ה שלכם. הביטו בדוגמה, ואז העלו את התמונה ישירות מכאן.',
  photoHelpUploadLabel: 'העלו את תמונת הילד/ה',
  photoHelpDone: 'המשך',
  photoHelpLater: 'אעלה מאוחר יותר',

  imageSectionTitle: 'תמונות הסיפור',
  imageTipsTrigger: 'איך מעלים תמונה טובה?',
  imageTipsTitle: 'טיפים לתמונה מושלמת',
  imageTipsClose: 'סגור',
  imageTipsItems: [
    'השתמש/י בתמונה ברורה ומוארת היטב, רצוי באור טבעי.',
    'וודא/י שפני הילד/ה נראים במלואם ופונים למצלמה.',
    'בחר/י תמונה של אדם אחד בלבד, ללא אנשים אחרים ברקע.',
    'הימנע/י ממשקפי שמש, כובעים ופילטרים שמשנים את המראה.',
    'ככל שרזולוציית התמונה גבוהה יותר, כך התוצאה תהיה מדויקת ויפה יותר.',
    'עדיף רקע פשוט ולא עמוס.',
  ],

  // Preview page
  previewScene: 'סצנה',
  previewLockedScene: 'הזמינו את הסיפור כדי לפתוח את כל הסצנות',
  previewLockedEditable: 'לאחר הרכישה תוכלו להחליף תמונות, לבקש עריכות ולאשר כל עמוד לפני השליחה',
  continueToCheckout: 'להזמנת הסיפור',
  previewFreeScene: 'סצנה חינמית',
  storyPreviewSubtitle: 'זו תצוגה מקדימה — הזמינו את הגרסה המלאה כדי לפתוח את כל הסצנות והאיורים',

  bookReadyTitle: 'הספר של ילדכם מוכן! 🎉',
  bookReadySubtitle: 'עיינו בסיפור המלא והורידו PDF לקריאה בכל זמן.',
  bookReadyDownloadHint: 'הגרסה המלאה באיכות דפוס — שמרו במכשיר ושתפו עם המשפחה.',
  bookPreparingTitle: 'משלימים את שאר עמודי הסיפור…',
  bookPreparingSubtitle: 'מציירים את כל הסצנות. השלב הזה אורך דקה-שתיים.',

  previewBannerTitle: 'אהבתם את תחילת הסיפור?',
  previewBannerText: 'פתחו את כל הסצנות והאיורים וקבלו את הסיפור המלא של ילדכם.',
  previewRiskReversal: 'לאחר הרכישה ניתן להחליף תמונות ולבקש עריכות — לא נשלח עד שתאשרו כל עמוד',

  previewAssuranceTitle: 'זו טיוטה ראשונית — ואנחנו משכללים אותה',
  previewAssuranceLead: 'מה שאתם רואים כעת הוא טיוטה שנוצרה במיוחד לילדכם. לפני שהסיפור מגיע אליכם, כל ספר עובר את הצוות שלנו:',
  previewAssuranceStep1: 'קוראים את הסיפור, בודקים את הטקסט ומתקנים כל שגיאה.',
  previewAssuranceStep2: 'בודקים את האיורים ומשפרים או מציירים מחדש כל סצנה שצריך.',
  previewAssuranceStep3: 'לא שולחים את הספר לדפוס עד שהוא מושלם.',
  previewAssuranceFoot: 'הבחנתם בפרט קטן? אל דאגה — אנחנו דואגים לכל הפרטים.',

  // "Need a hand?" hesitation offer (unpaid preview → WhatsApp)
  previewHelpBadge: 'עזרה חינם מהצוות שלנו',
  previewHelpTitle: 'רוצים תמונות מקצועיות יותר לספר של ילדכם?',
  previewHelpText: 'מה שאתם רואים כעת הוא טיוטה ראשונית. ספרו לנו איך אתם מדמיינים את הספר, ואנחנו נעזור לכם להפוך את התמונות למקצועיות ומוכנות לדפוס — שלב אחר שלב, וללא כל התחייבות.',
  previewHelpBullet1: 'נשלח לכם דוגמאות אמיתיות מספרים שהדפסנו',
  previewHelpBullet2: 'נסביר איך אנחנו משכללים את התמונות לקראת דפוס',
  previewHelpBullet3: 'נענה על כל שאלה שיש לכם',
  previewHelpCta: 'דברו איתנו בוואטסאפ',
  previewHelpReassure: 'מענה מהיר • ללא התחייבות • חינם',
  previewHelpDismiss: 'אמשיך לעיין',
  previewHelpClose: 'סגירה',
  previewHelpWaIntro: 'שלום 👋 יצרתי כרגע תצוגה מקדימה של ספר לילד/ה שלי ב״אני גיבור״, ואשמח לעזרתכם כדי להפוך את התמונות למקצועיות ומוכנות לדפוס. אפשר שתשלחו לי כמה דוגמאות ותסבירו לי איך זה עובד?',
  previewHelpWaBook: 'הספר: {book}',
  previewHelpWaChild: 'שם הילד/ה: {name}',

  // Checkout
  checkoutTitle: 'השלמת ההזמנה',
  checkoutFullName: 'שם מלא',
  checkoutPhone: 'מספר טלפון',
  checkoutCity: 'עיר / יישוב',
  checkoutNeighborhood: 'שכונה / אזור',
  checkoutAddress: 'כתובת מלאה',
  checkoutLandmark: 'סימן היכר / נקודת ציון',
  checkoutPostalCode: 'מיקוד',
  checkoutPostalCodeInvalid: 'נא להזין מיקוד תקין (מספרים בלבד)',
  checkoutOptional: 'אופציונלי',
  checkoutLandmarkPlaceholder: 'דוגמה: ליד בית הכנסת, מול בית הספר',
  checkoutNeighborhoodPlaceholder: 'דוגמה: שכונת הגפן',
  checkoutShippingHint: 'כדי לעזור לשליח להגיע, הוסיפו שכונה וסימן היכר.',
  checkoutPay: 'לתשלום',
  checkoutProcessing: 'מעביר לתשלום...',
  checkoutOrderSummary: 'סיכום ההזמנה',

  // Checkout success
  paymentConfirming: 'מאשר את התשלום',
  paymentConfirmingHint: 'רגע ונעביר אתכם לעמוד ההזמנה — אל תסגרו חלון זה',
  paymentSuccess: 'התשלום הצליח!',
  paymentSuccessDesc: 'תודה רבה! ההזמנה שלכם בהכנה',
  paymentPending: 'התשלום בבדיקה — נשלח לכם אישור בדוא"ל',
  viewOrder: 'צפייה בהזמנה',

  // Order detail
  orderTitle: 'פרטי ההזמנה',
  orderNumber: 'מספר הזמנה',
  orderStatus: 'סטטוס ההזמנה',
  orderDate: 'תאריך',
  orderShipping: 'כתובת למשלוח',
  orderShippingEdit: 'עריכת כתובת',
  orderShippingSave: 'שמירת כתובת',
  orderShippingSaving: 'שומר…',
  orderShippingCancel: 'ביטול',
  orderShippingLocked: 'לא ניתן לערוך את הכתובת לאחר תחילת המשלוח.',
  orderShippingUpdated: 'כתובת המשלוח עודכנה.',
  orderItems: 'מוצרים',
  orderBookTitle: 'הספר המלא',
  orderBookHint: 'צפו בסיפור המלא עם האיורים והורידו PDF.',
  orderBookView: 'צפייה בספר',
  orderBookLoading: 'טוען…',
  status_pending_payment: 'ממתין לתשלום',
  status_paid: 'שולם',
  status_in_production: 'בהפקה',
  status_shipped: 'נשלח',
  status_delivered: 'הגיע',
  status_payment_failed: 'התשלום נכשל',

  // Auth
  login: 'התחברות',
  register: 'הרשמה',
  logout: 'התנתקות',
  email: 'דוא"ל',
  password: 'סיסמה',
  loginBtn: 'כניסה',
  registerBtn: 'הרשמה',
  noAccount: 'אין לך חשבון?',
  hasAccount: 'יש לך חשבון?',
  myAccount: 'החשבון שלי',
  myOrders: 'ההזמנות שלי',
  myStories: 'הסיפורים שלי',

  autoLoginInProgress: 'מתחבר…',
  magicLinkExpired: 'קישור הכניסה פג תוקף. נא לבקש קישור חדש.',
  forgotPassword: 'שכחת סיסמה?',
  resetLinkSent: 'אם הדוא"ל רשום אצלנו, שלחנו קישור כניסה. בדקו את הדוא"ל.',
  enterEmailFirst: 'הזינו את הדוא"ל קודם ואז לחצו על "שכחת סיסמה?".',

  // Finalize / approve
  finalizeBannerTitle: 'סיימו את הבדיקה ואשרו לדפוס',
  finalizeBannerDesc: 'בדקו את הסיפור המלא, בקשו שינויים ואז אשרו לדפוס.',
  finalizeBannerCta: 'לעמוד הבדיקה',
  finalizeApprovedTitle: 'ההזמנה אושרה ✓',
  finalizeApprovedDesc: 'תודה! הסיפור שלכם בדרך לדפוס.',
  finalizeApprovedOn: 'תאריך אישור',
  finalizePageTitle: 'בדקו את הסיפור ואשרו לדפוס',
  finalizePageSubtitle: 'זו הגרסה המלאה. עיינו בה, בקשו שינויים אם צריך ולחצו אישור.',
  finalizingImages: 'יוצרים את שאר התמונות… זה עשוי לקחת דקה-שתיים.',

  finalizeLoaderTitle: 'משלימים את האיורים של הסיפור ✨',
  finalizeLoaderSubtitle: 'אנחנו מציירים את שאר הסצנות באותו סגנון. בדרך כלל זה לוקח דקה-שתיים — אל תסגרו עמוד זה.',
  finalizeStage1: 'מכינים את ההפניות והדמות…',
  finalizeStage2: 'מציירים את שאר הסצנות…',
  finalizeStage3: 'נגיעות אחרונות בסיפור…',
  requestChangesLabel: 'בקשו שינויים בסיפור',
  requestChangesPlaceholder: 'כתבו את השינויים שתרצו (נוסיף תכונה זו בקרוב)…',
  approveAndPrint: 'אישור ושליחה לדפוס',
  approving: 'מאשר…',
  backToOrder: 'חזרה להזמנה',

  // PDF → printed book upgrade
  upgradeBannerTitle: 'הפכו את העותק הדיגיטלי לספר מודפס',
  upgradeBannerDesc: 'שלמו רק את ההפרש — נקזז את מה ששילמתם עבור העותק הדיגיטלי ממחיר הספר המודפס.',
  upgradeBannerCta: 'שדרוג לספר מודפס',
  upgradePageTitle: 'שדרוג לספר מודפס',
  upgradePageSubtitle: 'בחרו סוג ספר — נקזז את מה ששילמתם קודם מהמחיר, ותשלמו רק את ההפרש.',
  upgradeBookPrice: 'מחיר הספר',
  upgradeAlreadyPaid: 'שולם קודם (עותק דיגיטלי)',
  upgradeRemaining: 'נותר לתשלום',
  upgradePay: 'תשלום ההפרש והשלמת השדרוג',
  upgradeDoneTitle: 'השדרוג הושלם ✓',
  upgradeDoneDesc: 'הזמנה זו שודרגה לספר מודפס.',
  upgradeDoneLink: 'צפייה בהזמנת השדרוג',
  upgradeNotEligible: 'הזמנה זו אינה זמינה לשדרוג.',
  upgradeBadge: 'שדרוג',

  // Admin approval
  adminColumnApproval: 'אישור',
  adminApprovedBadge: 'אושר ✓',
  adminColumnProduct: 'מוצר',
  pdfBadge: 'PDF',
  pdfIncludedTag: 'כולל PDF',

  // Contact / Social
  contactWhatsApp: 'וואטסאפ',

  // Cart
  cart: 'סל קניות',
  cartEmpty: 'הסל ריק',
  cartPendingHint: 'סיפורים אלה ממתינים לתשלום. השלימו את התשלום בכל זמן.',
  removeFromCart: 'הסרה',
  checkout: 'תשלום',
  completePayment: 'השלמת תשלום',
  completePaymentTitle: 'ההזמנה שלכם ממתינה לתשלום',
  completePaymentDesc: 'התשלום טרם הושלם. השלימו את התשלום כדי לשלוח את הסיפור להפקה.',
  total: 'סה"כ',
  subtotal: 'סכום ביניים',
  delivery: 'משלוח',
  cartChangeVariant: 'שינוי סוג',
  cartVariantClose: 'סגור',
  cartVariantSaving: 'שומר…',
  cartVariantLoadError: 'לא ניתן לטעון את הסוגים',
  cartVariantChangeError: 'לא ניתן לשנות את הסוג',

  // Admin
  admin: 'לוח בקרה',
  adminDashboard: 'לוח בקרה',
  adminCategories: 'קטגוריות',
  adminTemplates: 'תבניות',
  adminOrders: 'הזמנות',
  adminUsers: 'משתמשים',
  adminFeedback: 'ביקורות',
  adminSettings: 'הגדרות',
  adminActions: 'פעולות',
  adminMarkTest: 'סמן כבדיקה',
  adminUnmarkTest: 'הסר סימון בדיקה',
  adminDeleteOrder: 'מחק הזמנה',
  adminConfirm: 'אישור',
  adminCancel: 'ביטול',
  adminSave: 'שמירה',
  adminConfirmTitle: 'אישור פעולה',
  adminConfirmDeleteOrder: 'הזמנה זו תימחק לצמיתות ולא ניתן לבטל. להמשיך?',
  adminConfirmMarkTest: 'הזמנה זו תסומן כנתוני בדיקה ותוסתר מהסטטיסטיקות ומהרשימה. להמשיך?',
  adminConfirmUnmarkTest: 'סימון הבדיקה יוסר מהזמנה זו והיא תופיע בין ההזמנות האמיתיות. להמשיך?',
  adminAddOrder: 'הוספת הזמנה',
  adminAddOrderTitle: 'הוספת הזמנה ידנית',
  adminOrderName: 'שם הלקוח',
  adminOrderAmount: 'סכום ששולם',
  adminProductType: 'מוצר',
  adminAddOrderNeedContact: 'הזן/י שם או דוא"ל לפחות',

  // Admin Dashboard
  adminShowTestData: 'הצג נתוני בדיקה',
  adminCreatePreviewForCustomer: 'צור תצוגה מקדימה ללקוח',
  adminBuildStoryManually: 'בנה סיפור ידנית',
  adminSeries: 'סדרות',
  adminStatistics: 'סטטיסטיקה',
  adminAtcTitle: 'הוספות לעגלה',
  adminAtcHint: 'אילו סיפורים נוספים לעגלת התשלום-מראש, לפי מקור המבקר: מודעות preview=0, ניסוי A/B או אחר. בוטים מסוננים.',
  adminAtcVariantUrl: 'מודעה (preview=0)',
  adminAtcVariantFlag: 'ניסוי A/B',
  adminAtcVariantControl: 'אחר',
  adminAtcVariantUnknown: 'לא ידוע',
  adminAtcFunnelTitle: 'משפך הרכישה — כמות (מבקרים)',
  adminAtcByStoryTitle: 'לפי סיפור',
  adminAtcRecentTitle: 'הוספות אחרונות',
  adminAtcNoData: 'אין הוספות בתקופה זו עדיין.',
  adminAtcStep: 'שלב',
  adminAtcStepAtc: 'נוסף לעגלה',
  adminAtcStepCheckoutView: 'פתח את דף התשלום',
  adminAtcStepCheckoutSubmit: 'שלח תשלום',
  adminAtcStepCreated: 'יצר את הסיפור לאחר תשלום',
  adminAtcStory: 'סיפור',
  adminAtcTotal: 'סה״כ',
  adminAtcLast: 'הוספה אחרונה',
  adminAtcTime: 'זמן',
  adminAtcSource: 'מקור',
  adminAtcVisitor: 'מבקר',
  adminAtcRange1: 'היום',
  adminAtcRange7: '7 ימים',
  adminAtcRange14: '14 יום',
  adminAtcRange30: '30 יום',
  adminRevenue: 'הכנסות',
  adminStories: 'סיפורים',
  adminAiCost: 'עלות בינה מלאכותית',
  adminPreviewAttempts: 'ניסיונות תצוגה מקדימה',
  adminPreviewsReady: 'תצוגות מוכנות',
  adminRecentPreviewAttempts: 'ניסיונות תצוגה מקדימה אחרונים',
  adminSearchPlaceholder: 'חיפוש לפי שם ילד/ה, שם, מייל, טלפון או קוד שיתוף…',
  adminColChild: 'ילד/ה',
  adminColRequester: 'מזמין/ה',
  adminColContact: 'יצירת קשר',
  adminColStory: 'סיפור',
  adminColProduct: 'מוצר',
  adminColPrice: 'מחיר',
  adminColPayment: 'תשלום',
  adminColStatus: 'סטטוס',
  adminColCost: 'עלות',
  adminColTime: 'זמן',
  adminColActions: 'פעולות',
  adminPaid: 'שולם',
  adminUnpaid: 'לא שולם',
  adminEditScenes: 'עריכת סצנות',
  adminView: 'צפייה',
  adminDemo: 'גרסת דמו',
  adminCopyDemoLink: 'העתקת קישור דמו',
  adminDemoLinkCopied: 'הקישור הועתק ✓',
  adminDelete: 'מחיקה',
  adminNoAttemptsYet: 'אין ניסיונות עדיין',
  adminCostEstimateNote: 'העלות משוערת בדולר (מחירי ספקים).',
  adminPrevPage: 'הקודם',
  adminNextPage: 'הבא',
  showcaseTitle: 'עלעלו בסיפורים שלמים',
  showcaseSubtitle: 'אלה ספרים אמיתיים שלנו — פתחו כל ספר וקראו אותו עמוד אחר עמוד לפני שתזמינו את שלכם.',
  showcaseOpen: 'לפתוח את הספר',
  showcasePages: 'עמודים',
  showcasePrev: 'הקודם',
  showcaseNext: 'הבא',
  adminDuplicate: 'שכפול',
  adminDuplicateStory: 'יצירת עותק של הסיפור',
  adminDuplicateTitle: 'יצירת עותק',
  adminDuplicateMessage: 'ייווצר סיפור חדש עם אותן סצנות, טקסטים, תמונות וכריכה, וניתן לערוך אותו בנפרד. בחר את מאפייני העותק:',
  adminDuplicateStatusLabel: 'סטטוס העותק',
  adminDuplicateTestLabel: 'סימון כנתוני בדיקה',
  adminDuplicatePaidLabel: 'סימון כשולם (תיווצר הזמנה מקושרת)',
  adminDuplicateSubmit: 'יצירת העותק',
  adminDuplicateFailed: 'יצירת העותק נכשלה',
  adminDuplicateRecastLabel: 'עותק לילד אחר (שינוי שם, מגדר ותמונה)',
  adminDuplicateChildName: 'שם הגיבור החדש',
  adminDuplicateChildGender: 'מגדר הגיבור',
  adminDuplicateChildPhoto: 'תמונת הילד החדש',
  adminDuplicateUploadPhoto: 'העלאת תמונה',
  adminDuplicateChangePhoto: 'החלפת תמונה',
  adminGenderBoy: 'ילד',
  adminGenderGirl: 'ילדה',
  adminDuplicateRedrawLabel: 'ציור מחדש של כל האיורים עם הילד החדש',
  adminDuplicateRedrawHint: 'האיורים נשארים זהים לחלוטין — אותו הרכב, תנוחה, רקע ולבוש — ורק הילד מתחלף. התהליך רץ ברקע עמוד אחר עמוד.',
  adminRecastRunning: 'מציירים מחדש את האיורים עם הילד החדש',
  adminRecastDone: 'ציור האיורים מחדש הושלם',
  adminRecastPartial: 'עמודים שלא הושלמו',
  adminDeletePreviewTitle: 'מחיקת תצוגה מקדימה',
  adminDeletePreviewMessage: 'רשומת התצוגה המקדימה תימחק לצמיתות ולא ניתן לשחזרה. להמשיך?',
  adminDeleteFailed: 'המחיקה נכשלה',
  adminSaveFailed: 'השמירה נכשלה',
  adminActionFailed: 'הפעולה נכשלה',
  adminStatusPreviewing: 'בתהליך יצירה',
  adminStatusPreviewReady: 'מוכנה',
  adminStatusFinalizing: 'בתהליך השלמה',
  adminStatusFinalized: 'הושלמה',
  adminStatusIterating: 'בתהליך עריכה',
  adminStatusLockedForPrint: 'מוכנה לדפוס',
  adminStatusFailed: 'נכשלה',
  adminStatusUnknown: 'לא ידוע',
  adminVariantSoftcover: 'כריכה רכה',
  adminVariantHardcover: 'כריכה קשה',
  adminStatusCancelled: 'בוטלה',
  adminPaymentCard: '💳 כרטיס',
  adminPaymentCash: '💵 מזומן',
  adminPaymentBankTransfer: '🏦 העברה בנקאית',
  adminOrderSearchPlaceholder: 'חיפוש לפי מספר הזמנה, שם, מייל, טלפון או מספר מעקב…',
  adminFilterAll: 'הכל',
  adminManualBadge: 'ידני',
  adminTestBadge: 'בדיקה',
  adminViewPreview: 'צפייה בתצוגה מקדימה',
  adminChangePaymentMethod: 'לחץ/י לשינוי אמצעי תשלום',
  adminEditAmount: 'עריכת סכום',
  adminViewOnly: 'צפייה בלבד',
  adminColPaymentMethod: 'תשלום',
  adminColAction: 'פעולה',

  // Admin Settings
  adminSettingsTitle: 'הגדרות',
  adminStripeHelp: 'המפתח הפעיל משתנה מיד בעת מעבר בין מצבים — אין צורך בהפעלה מחדש.',
  adminStripeMode: 'מצב Stripe',
  adminStripeKeysHint: 'קורא מפתחות מ-',
  adminSkipStripe: 'דלג על Stripe',
  adminSkipStripeHint: 'לפיתוח בלבד — ההזמנה נחשבת משולמת מיד',
  adminAiProviders: 'ספקי בינה מלאכותית',
  adminAiProvidersHelp: 'השינויים חלים על הזמנות חדשות מיד עם השמירה. מפתחות ה-API נשארים בקובץ .env.',
  adminStoryGeneration: 'יצירת סיפור',
  adminIterationCap: 'תקרת חזרות לכל סצנה',
  adminIterationCapHint: 'מספר הניסיונות המרבי ליצירה מחדש של סצנה שלא הצליחה',
  adminStoryFont: 'גופן טקסט הסיפור',
  adminStoryFontHelp: 'הגופן חל על טקסט כל הסיפורים — גם בספר המודפס (PDF) וגם בצפייה במסך. כותרות העטיפה שומרות על הגופן הנפרד שלהן לכל סיפור.',
  adminStoryFontLabel: 'גופן',
  adminStoryFontHint: 'חל על כל הקבצים שנוצרים אחרי השמירה; קבצים שכבר נוצרו אינם משתנים.',
  adminStoryFontSample: 'في المساء، جلس البطل قرب النافذة ونظر إلى النجوم، ثم ابتسم وقال: غداً يومٌ جديد.',
  adminMasterPrompt: 'פרומפט ראשי (Master Prompt)',
  adminMasterPromptEnabled: 'פעיל',
  adminMasterPromptDisabled: 'כבוי',
  adminMasterPromptHelp: 'כשמופעל, פרומפט זה מחליף את כל מסלולי הסיפורים (גיבורים, דמיון, פחדים, תחנות…) והופך לפרומפט היחיד ליצירת הסיפור. אנחנו מוסיפים סביבו רק את פרטי הילד/ה (שם, גיל, מגדר, נושא…) לפניו, והנחיות מבנה (מספר עמודים, שפה, פורמט JSON) אחריו. כשמכבים אותו המערכת חוזרת למסלולים הרגילים.',
  adminPromptText: 'טקסט הפרומפט',
  adminPromptPlaceholder: 'כתוב/י כאן את הפרומפט המלא ליצירת הסיפור…\nניתן להשתמש בפרטי הילד/ה המועברים לפני טקסט זה (שם, גיל, מגדר, נושא, תוצאה רצויה…).',
  adminPromptOutputHint: 'אין לכתוב כאן את פורמט הפלט (JSON) או מספר העמודים — מתווספים אוטומטית אחרי הפרומפט.',
  adminProductCatalog: 'קטלוג מוצרים ומחירים',
  adminAddProduct: '+ הוספת מוצר',
  adminProductCatalogHelp: 'כל וריאנט בתבניות מקושר למוצר מכאן. המחיר מועבר ל-Stripe כ-price_data בזמן אמת — אין צורך ביצירת Price IDs.',
  adminProductKey: 'מפתח (key)',
  adminProductName: 'שם',
  adminProductPrice: 'מחיר',
  adminProductCompareAt: 'לפני הנחה',
  adminProductCurrency: 'מטבע',
  adminProductKeyRequired: 'כל מוצר צריך מפתח (key)',
  adminProductNameRequired: 'צריך שם',
  adminProductKeysDuplicate: 'מפתחות המוצרים כפולים',
  adminNoProductsYet: 'אין מוצרים עדיין — לחץ/י "הוספת מוצר"',
  adminDeliveryFees: 'דמי משלוח',
  adminDeliveryFeesHelp: 'דמים אלה מתווספים אוטומטית לכל הזמנה מודפסת (כריכה רכה או קשה) בעת התשלום, ומוצגים ללקוח כפריט נפרד לפני Stripe ובדף התשלום.',
  adminDeliveryAmount: 'סכום משלוח',
  adminCurrencyField: 'מטבע',
  adminGradBanner: 'באנר סדרת סיום גן',
  adminGradBannerHelp: 'הצגה או הסתרה של באנר סדרת סיום הגן בעמוד הבית (הפותח בקשת וואטסאפ מיוחדת לכיתה).',
  adminPromoBanner: 'מבצע (באנר)',
  adminBannerImage: 'תמונת באנר',
  adminBannerAlt: 'באנר',
  adminUploading: 'מעלה…',
  adminPromoPrice: 'מחיר מבצע (לספרים)',
  adminBundleQty: 'מספר ספרים בחבילה',
  adminProductTypeLabel: 'סוג מוצר',
  adminStartsAt: 'מתחיל ב-',
  adminEndsAt: 'מסתיים ב-',
  adminUnsavedChanges: 'השינויים אינם נשמרים אוטומטית',
  adminSaving: 'שומר…',
  adminSaveAllSettings: 'שמירת כל ההגדרות',
  adminSaved: 'נשמר',
  adminImageUploadFailed: 'העלאת התמונה נכשלה',
  adminBackToDashboard: '← לוח בקרה',
  adminBannerGradSeries: 'באנר סדרת סיום גן',
  adminBannerPromo: 'באנר מבצע',

  // Admin Stats
  adminRangeToday: 'היום',
  adminRange7Days: '7 ימים',
  adminRange30Days: '30 יום',
  adminRange90Days: '90 יום',
  adminRangeAll: 'כל הזמן',
  adminRangeCustom: 'מותאם אישית',
  adminExpenseAds: 'פרסום',
  adminExpenseAi: 'בינה מלאכותית',
  adminExpensePrinting: 'דפוס',
  adminExpenseDelivery: 'משלוח',
  adminExpenseOther: 'אחר',
  adminFrom: 'מ-',
  adminTo: 'עד',
  adminSelectDateRange: 'בחר/י תאריך התחלה וסיום',
  adminConversionFunnel: 'משפך המרה',
  adminVisitors: 'מבקרים',
  adminPreviews: 'תצוגות מקדימות',
  adminPurchases: 'רכישות',
  adminFinancialPerformance: 'ביצועים פיננסיים',
  adminProductsCost: 'עלות מוצרים (דפוס+משלוח+בינה)',
  adminExpensesLabel: 'הוצאות (פרסום…)',
  adminNetProfit: 'רווח נקי',
  adminProfitMargin: 'שיעור רווח',
  adminActualAiSpend: 'הוצאת בינה בפועל (לעיון)',
  adminDailyIncomeSpend: 'הכנסות והוצאות יומיות',
  adminIncome: 'הכנסות',
  adminSpend: 'הוצאות',
  adminCostRates: 'תעריפי עלות',
  adminBookPrinting: 'דפוס ספר (₪)',
  adminDeliveryCost: 'משלוח (₪)',
  adminExchangeRate: 'שער חליפין דולר',
  adminSaveRates: 'שמירת תעריפים',
  adminAiCostNote: 'עלות הבינה המלאכותית מחושבת מההוצאה בפועל לכל סיפור (בדולר) כפול שער החליפין.',
  adminExpenses: 'הוצאות',
  adminExpenseDescription: 'תיאור',
  adminExpenseType: 'סוג',
  adminExpenseAmount: 'סכום (₪)',
  adminExpensePeriod: 'תקופה',
  adminExpensePeriodOption: 'תקופה (מחולק ליום)',
  adminExpenseOneTime: 'חד-פעמי',
  adminExpenseDate: 'תאריך',
  adminExpenseAdd: 'הוספה',
  adminNoExpensesYet: 'אין הוצאות עדיין',
  adminExpenseDescPlaceholder: 'דוגמה: קמפיין פייסבוק ספטמבר',
  adminNoDataYet: 'אין נתונים',
  adminEmailTracking: 'מעקב אימיילים',
  adminEmailRecipient: 'נמען',
  adminEmailType: 'סוג',
  adminEmailSubject: 'נושא',
  adminEmailSent: 'נשלח',
  adminEmailOpened: 'נפתח?',
  adminEmailOpenTime: 'זמן פתיחה',
  adminEmailOpenCount: 'פעמים',
  adminEmailYes: 'כן',
  adminEmailNo: 'לא',
  adminEmailStatus: 'סטטוס',
  adminEmailFilterOpened: 'נפתחו',
  adminEmailFilterNotOpened: 'לא נפתחו',
  adminNoEmailsYet: 'אין אימיילים מתועדים עדיין',
  adminEmailCount: 'אימייל',
  adminMostViewedStories: 'הנצפים ביותר (סיפורים)',
  adminMostPreviewed: 'הנצפים מקדימה ביותר',
  adminMostViewedCategories: 'הנצפים ביותר (קטגוריות)',
  adminViewCountLabel: 'צפייה',
  adminPreviewCountLabel: 'תצוגה מקדימה',
  adminRankName: 'שם',
  adminEmailTypeOrderConfirmation: 'אישור הזמנה',
  adminEmailTypeStoryReady: 'הסיפור מוכן',
  adminEmailTypeStoryPdf: 'מסירת PDF',
  adminEmailTypeBookReady: 'הספר מוכן',
  adminEmailTypeTeaser: 'תזכורת תצוגה',
  adminEmailTypeStoryFinalize: 'סקירה ואישור',
  adminEmailTypeAccountCreated: 'חשבון חדש',
  adminEmailTypeMagicLogin: 'קישור כניסה',
  adminEmailTypePasswordReset: 'שחזור סיסמה',
  adminEmailTypePaymentNotice: 'הודעת תשלום (פנימי)',
  adminEmailTypeUnknown: 'אחר',
  adminEmailFilterAll: 'הכל',
  adminEmailPaymentNoticeShort: 'הודעת תשלום',

  // Admin Story
  adminNoImage: 'אין תמונה',
  adminRegeneratingImage: 'מייצר…',
  adminRegenerateImage: 'יצירת תמונה מחדש',
  adminUploadingImage: 'מעלה…',
  adminUploadFromDevice: 'העלאת תמונה מהמכשיר',
  adminRegenCount: 'מספר יצירות: ',
  adminTextPreviewLabel: 'תצוגת הטקסט כפי שיופיע בעמוד',
  adminSceneTextLabel: 'טקסט הסצנה ',
  adminMoveUp: 'הזז למעלה',
  adminMoveDown: 'הזז למטה',
  adminDeleteScene: 'מחיקת סצנה',
  adminFontSizeLabel: 'גודל גופן (נק\' pt — השאר/י ריק לגודל אוטומטי)',
  adminAutomatic: 'אוטומטי',
  adminImagePromptLabel: 'תיאור התמונה (image prompt)',
  adminGeneratePromptFromText: '✨ יצירת תיאור מטקסט הסצנה',
  adminGeneratePromptHint: 'מייצר תיאור תמונה באנגלית מטקסט הסצנה למעלה. ערוך/י ואז לחץ/י "יצירת תמונה מחדש".',
  adminRefImagesLabel: 'תמונות ייחוס לסצנה זו',
  adminRefImagesHelp: 'תמונות אלו נשלחות עם יצירת סצנה זו בלבד (בנוסף לייחוס הדמות) — למשל חפץ או רקע שצריכים להופיע.',
  adminRefSubjectPlaceholder: 'מה מייצגת התמונה? (אופציונלי) דוגמה: אופניים אדומים',
  adminDeleteRefImage: 'מחיקת תמונת ייחוס',
  adminAddingRef: 'מוסיף…',
  adminAddRefImage: '+ הוספת תמונת ייחוס',
  adminSavingText: 'שומר…',
  adminSaveText: 'שמירת טקסט',
  adminSavedCheckmark: 'נשמר ✓',
  adminNoCover: 'אין כריכה',
  adminFrontCoverHint: 'כריכה קדמית — גרור/י את הכותרת להזזה, ולחץ/י על שורה לעיצוב',
  adminTrimLine: 'קו חיתוך — 2 ס"מ',
  adminShowTrimGuide: 'הצגת קו חיתוך (2 ס"מ) — לתצוגה מקדימה בלבד, לא מופיע בספר',
  adminSaveTitlePos: 'שמירת מיקום הכותרת',
  adminResetTitlePos: 'איפוס למיקום ברירת מחדל',
  adminFullCoverPrint: 'כריכה מלאה לדפוס (קדמית שמאל + אחורית ימין)',
  adminRegenerateCover: 'יצירת כריכה מחדש',
  adminUploadCover: 'העלאת כריכה מהמכשיר',
  adminStoryTitleLabel: 'כותרת הסיפור',
  adminStoryTitlePlaceholder: 'כותרת הסיפור כפי שמופיעה על הכריכה והספר',
  adminSaveTitle: 'שמירת כותרת',
  adminCoverConcept: 'רעיון הכריכה (cover concept)',
  adminCoverConceptPlaceholder: 'תאר/י את סצנת/רעיון הכריכה באנגלית (מקום, אלמנט ויזואלי מרכזי, אווירה). סגנון הציור האוטומטי (חצי-ריאליסטי מצויר) מוחל תמיד — אין לכתוב סוג ציור. השאר/י ריק לכריכת ברירת מחדל.',
  adminCoverRefImages: 'תמונות ייחוס לכריכה',
  adminCoverRefHelp: 'תמונות אלו נשלחות עם יצירת הכריכה (בנוסף לייחוס הדמות) — למשל חפץ או רקע שצריכים להופיע על הכריכה. מופיעות ליד הגיבור/ה בצד שמאל.',
  adminCoverTitleColor: 'צבע כותרת הכריכה',
  adminDarkText: 'טקסט כהה',
  adminLightText: 'טקסט בהיר',
  adminTitleDesign: 'עיצוב כותרת',
  adminTitleDesignHelp: 'לחץ/י על כל שורה מהכותרת בתצוגה למעלה כדי לעצב אותה (גופן, צבעים, גבולות, גודל, ריווח).',
  adminOpenTitleEditor: '✎ פתיחת עורך הכותרת',
  adminTextBubble: 'בועה מצוירת ביד מאחורי הטקסט',
  adminTextBubbleSaving: ' — שומר…',
  adminDragTitleHint: 'גרור/י להזזת הכותרת — לחץ/י על שורה לעיצוב',
  adminTitleDesigner: '⠿ עיצוב כותרת',
  adminCloseTitleEditor: 'סגירה',
  adminTitleLine: 'שורה ',
  adminFont: 'גופן',
  adminDefault: 'ברירת מחדל',
  adminSizePt: 'גודל (pt)',
  adminWeight: 'עובי',
  adminColor: 'צבע',
  adminBorder: 'גבולות',
  adminBorderWidth: 'עובי גבולות',
  adminLetterSpacing: 'ריווח אותיות (em)',
  adminBoxWidth: 'רוחב תיבה: ',
  adminLineSpacing: 'ריווח שורות: ',
  adminSaveBtn: 'שמירה',
  adminResetBtn: 'איפוס',
  adminNoPortrait: 'אין תמונת דיוקן לסיפור זה עדיין.',
  adminDedicationImage: 'תמונת עמוד הקדשה',
  adminDedicationHeroImage: 'עמוד הקדשה — תמונת הגיבור/ה',
  adminDedicationUploadHelp: 'העלה/י את תמונת הילד/ה שמופיעה בעיגול עמוד ההקדשה.',
  adminReplaceImage: 'החלפת תמונה',
  adminImageFraming: 'מסגור תמונה',
  adminFramingHelp: 'גרור/י את התמונה בתוך העיגול להזזה, והשתמש/י בסרגל להגדלה — כדי שתיראה נכון בספר ובקובץ ה-PDF.',
  adminZoom: 'הגדלה',
  adminSaveFraming: 'שמירת מסגור',
  adminBackCover: 'כריכה אחורית',
  adminBackCoverSummaryLabel: 'טקסט תיאורי (חלק עליון של הכריכה האחורית)',
  adminBackCoverAutoPrefix: 'השאר/י ריק לשימוש בטקסט האוטומטי: ',
  adminBackCoverDedicationLabel: 'הקדשה (חלק תחתון של הכריכה האחורית)',
  adminBackCoverDedicationAutoPrefix: 'השאר/י ריק לשימוש בהקדשה האוטומטית: ',
  adminSaveBackCover: 'שמירת כריכה אחורית',
  adminHeroDetails: 'פרטי הגיבור/ה',
  adminHeroDetailsHelp: 'שם הגיבור/ה ומגדרו/ה מופיעים בהקדשה ובטקסט התיאורי על הכריכה האחורית.',
  adminHeroName: 'שם הגיבור/ה',
  adminHeroNamePlaceholder: 'שם הילד/ה בסיפור',
  adminGender: 'מגדר',
  adminGenderUnspecified: '— לא צוין —',
  adminGenderBoy: 'בן',
  adminGenderGirl: 'בת',
  adminAgeLabel: 'גיל',
  adminAgePlaceholder: 'דוגמה: 4',
  adminSaveHeroDetails: 'שמירת פרטי הגיבור/ה',
  adminOrderDetailsHeading: 'פרטי הזמנה',
  adminAllOrders: 'כל ההזמנות',
  adminCustomerName: 'שם הלקוח/ה',
  adminEmailLabel: 'דוא"ל',
  adminPhoneLabel: 'טלפון',
  adminProductTypeField: 'סוג מוצר',
  adminPriceField: 'מחיר (₪)',
  adminQuantity: 'כמות',
  adminOrderStatusField: 'סטטוס הזמנה',
  adminStatusNotPaid: 'לא שולם',
  adminStatusPaid: 'שולם',
  adminStatusInProduction: 'בהפקה',
  adminStatusShipped: 'נשלח',
  adminStatusDelivered: 'נמסר',
  adminStatusCancelledLabel: 'בוטל',
  adminSaveOrderDetails: 'שמירת פרטי הזמנה',
  adminPreparingPdf: 'מכין PDF…',
  adminDownloadBookPdf: 'הורדת הספר PDF',
  adminPdfCover: 'PDF כריכה',
  adminPdfContent: 'PDF תוכן (עמוד עמוד)',
  adminProductSoftcover: 'כריכה רכה',
  adminProductHardcover: 'כריכה קשה',
  adminProductDigital: 'עותק דיגיטלי (PDF)',
  adminImageStyle: 'סגנון ציורים',
  adminImageStyleHelpText: 'אופן ציור כל תמונות הסיפור. לאחר שינוי ושמירה ניתן ליצור מחדש את כל התמונות הקיימות בסגנון החדש בלחיצה אחת.',
  adminStyleCartoon: 'קרטון',
  adminStyle3d: 'תלת-ממד',
  adminStyleRealistic: 'ריאליסטי',
  adminSaveStyle: 'שמירת סגנון',
  adminRegenImagesProgress: 'מייצר תמונות מחדש… ',
  adminCurrentStyle: 'סגנון נוכחי: ',
  adminEditScenesTitle: 'עריכת סצנות',
  adminStoryDefault: 'סיפור',
  adminHeroLabel: 'הגיבור/ה: ',
  adminStatusPrefix: 'סטטוס: ',
  adminViewSeries: '📚 צפייה בסדרה',
  adminCreateSeriesFromStory: '📚 יצירת סדרה מסיפור זה',
  adminPreviewLinkLabel: 'קישור תצוגה מקדימה ללקוח (צפייה + תשלום):',
  adminCopied: 'הועתק ✓',
  adminCopyLink: '📋 העתקת קישור',
  adminOpenPreview: 'פתיחת תצוגה מקדימה ↗',
  adminCopyFullScript: '📋 העתקת כל טקסט הסיפור',
  adminCreatingCopy: 'יוצר העתק…',
  adminNewPreviewOpened: 'התצוגה המקדימה החדשה נפתחה בלשונית אחרת — לחץ/י כאן אם לא נפתחה',
  adminAddSceneEnd: '+ הוספת סצנה חדשה בסוף',
  adminBusy: 'מעבד…',
  adminGoBack: 'חזרה',
  adminDedicationPortraitOptional: 'תמונת עמוד הקדשה (אופציונלי)',
  adminChangeImage: 'החלפת תמונה',
  adminRemove: 'הסרה',

  // Admin Story Build
  adminBuildStoryTitle: 'בניית סיפור ידנית',
  adminBackToOrders: 'חזרה להזמנות',
  adminBuildStoryDesc: 'צור/י ספר חיצוני ידנית: כותרת, סצנות ופרטי הזמנה. לאחר היצירה ניתן להוסיף תמונות כריכה וסצנות (העלאת תמונה או יצירה מתמונת ייחוס + תיאור) בעורך הסיפור.',
  adminVersionType: 'סוג גרסה',
  adminFullVersion: 'גרסה מלאה (מוכנה להפקה)',
  adminFullVersionDesc: 'ספר סופי עם כל הסצנות והתמונות — מטופל כסיפור שהושלם.',
  adminPreviewVersion: 'תצוגה מקדימה (Preview)',
  adminPreviewVersionDesc: 'כמו תצוגה מקדימה של הלקוח: הוסף/י תמונת כריכה וסצנה ראשונה בלבד, ושאר הסצנות נשארות נעולות. שלח/י את קישור התצוגה המקדימה ללקוח לצפייה ותשלום.',
  adminPaymentStatus: 'סטטוס תשלום',
  adminScenes: 'סצנות',
  adminAllScenesFontSize: 'גודל גופן לכל הסצנות (נק\' pt — מוחל על כל הסצנות)',
  adminPerSceneFontOverride: 'ניתן לשנות גודל גופן לסצנה מסוימת למטה, והוא יגבור על הערך הכללי.',
  adminSceneFontSizeHint: 'גודל גופן (נק\' pt — השאר/י ריק לשימוש בערך הכללי)',
  adminAddScene: '+ הוספת סצנה',
  adminEnterStoryTitle: 'הזן/י כותרת לסיפור',
  adminCreating: 'יוצר…',
  adminCreateAndContinue: 'יצירת הסיפור והמשך עריכה',
  adminCreateStoryFailed: 'יצירת הסיפור נכשלה',
  adminGlobalSuffix: '(כללי)',

  // Admin Templates
  adminTemplateName: 'שם',
  adminTemplateVariants: 'וריאנטים',
  adminTemplateFrom: 'מ-',
  adminTemplateActive: 'פעיל',
  adminTemplateInactive: 'כבוי',
  adminTemplateAction: 'פעולה',
  adminTemplateClose: 'סגירה',
  adminTemplateEdit: 'עריכה',
  adminTemplateTagline: 'תיאור קצר',
  adminTemplateDescription: 'תיאור',
  adminTemplateCoverUrl: 'קישור תמונת כריכה',
  adminTemplateSortOrder: 'סדר תצוגה',
  adminTemplateFeatured: 'הכי מבוקש',
  adminTemplateVariantsTitle: 'וריאנטים ומוצרים',
  adminTemplateAddVariant: '+ הוספת וריאנט',
  adminTemplateVariantType: 'סוג',
  adminTemplateVariantProduct: 'מוצר (מחיר)',
  adminTemplateVariantEnabled: 'פעיל',
  adminTemplateSelectProduct: '— בחר/י מוצר —',
  adminTemplateNoVariants: 'אין וריאנטים עדיין',
  adminTemplateNoProducts: 'אין מוצרים בקטלוג עדיין. הוסף/י מ',
  adminTemplateSettingsLink: 'הגדרות',
  adminTemplateNeedProducts: 'הוסף/י מוצרים קודם בהגדרות לפני קישור וריאנטים',
  adminTemplateSkuRequired: 'כל וריאנט צריך SKU',
  adminTemplateProductRequired: 'כל וריאנט צריך בחירת מוצר',
  adminTemplateSaving: 'שומר…',
  adminTemplateSave: 'שמירה',
  adminTemplateCancelEdit: 'ביטול',

  // Admin Users
  adminUserName: 'שם',
  adminUserRole: 'תפקיד',
  adminUserDate: 'תאריך הרשמה',

  // Series
  adminSeriesStatusDraft: 'טיוטה',
  adminSeriesStatusGenerating: 'מייצר…',
  adminSeriesStatusReady: 'מוכן',
  adminSeriesStatusFailed: 'נכשל',
  adminSeriesSameStory: 'אותו סיפור',
  adminSeriesNewStory: 'סיפור חדש',
  adminSeriesSameGraphics: 'אותם ציורים',
  adminSeriesNewGraphics: 'ציורים חדשים',
  adminSeriesChildren: ' ילדים',
  adminSeriesApprovedCount: ' מאושרים',
  adminSeriesDefaultPrice: 'מחיר ברירת מחדל (₪): ',
  adminSeriesTest: 'סדרת בדיקה',
  adminSeriesAddChild: '+ הוספת ילד/ה',
  adminSeriesAdd5: '+ הוספת 5',
  adminSeriesChildName: 'שם הילד/ה',
  adminSeriesChildAge: 'גיל',
  adminSeriesChildPhoto: 'תמונת הילד/ה:',
  adminSeriesRefPhoto: 'תמונת ייחוס:',
  adminSeriesUploading: '…מעלה',
  adminSeriesChange: 'שינוי',
  adminSeriesUpload: 'העלאה',
  adminSeriesUploadPhotoFirst: 'העלה/י תמונת ילד/ה לפני יצירת הספר.',
  adminSeriesCreateBook: 'יצירת הספר',
  adminSeriesRegenerate: 'יצירה מחדש',
  adminSeriesRetry: 'ניסיון חוזר',
  adminSeriesGenerating: '…מייצר',
  adminSeriesEditScenes: 'עריכת סצנות',
  adminSeriesViewPdf: 'צפייה ב-PDF',
  adminSeriesApprove: 'אישור',
  adminSeriesApprovedBadge: '✓ מאושר',
  adminSeriesDeleteChild: '🗑 מחיקה',
  adminSeriesDeleteConfirm: 'למחוק ילד/ה זה מהסדרה?',
  adminSeriesTitle: 'כותרת הסדרה',
  adminSeriesPdfFailed: 'לא ניתן לפתוח את קובץ ה-PDF',
  adminSeriesLoadFailed: 'הטעינה נכשלה',
  adminSeriesLoading: 'טוען…',
  adminSeriesListTitle: 'סדרות',
  adminSeriesEmptyHelp: 'אין סדרות עדיין. פתח/י סיפור מוכן ולחץ/י "יצירת סדרה מסיפור זה".',
  adminSeriesColTitle: 'כותרת',
  adminSeriesColChildren: 'ילדים',
  adminSeriesColApproved: 'מאושרים',
  adminSeriesColType: 'סוג',
  adminSeriesColDate: 'תאריך',
  adminCreateSeries: 'יצירת סדרה',
  adminFromStory: 'מהסיפור: ',
  adminStepStory: 'הסיפור',
  adminStepGraphics: 'ציורים',
  adminStepCount: 'כמות',
  adminStepChildren: 'ילדים (אופציונלי)',
  adminStoryText: 'הסיפור (טקסט)',
  adminSameStory: 'אותו סיפור',
  adminSameStoryDesc: 'אותו טקסט בדיוק, עם החלפת השם והתאמת זכר/נקבה לכל ילד/ה.',
  adminNewStoryPerChild: 'סיפור חדש לכל ילד/ה',
  adminNewStoryPerChildDesc: 'אותה תבנית ורעיון, אבל הבינה המלאכותית כותבת טקסט חדש לכל ילד/ה.',
  adminGraphicsLabel: 'ציורים',
  adminSameGraphicsLabel: 'אותם ציורים',
  adminSameGraphicsDesc: 'אותן תמונות בדיוק עם החלפת פני הילד/ה — מקבעים את תמונת הסיפור המקורי כייחוס ומבקשים מהמודל ליצור אותה מחדש באותה קומפוזיציה.',
  adminNewGraphics: 'ציורים חדשים',
  adminNewGraphicsDesc: 'מייצרים תמונות חדשות לכל ילד/ה לפי הטקסט, תוך שמירה על הסגנון.',
  adminWizardSettings: 'הגדרות',
  adminChildrenCount: 'מספר ילדים',
  adminSeriesTitleField: 'כותרת הסדרה',
  adminSeriesTitlePlaceholder: 'לדוגמה: גן התקווה - כיתה א',
  adminDefaultPricePerBook: 'מחיר ברירת מחדל לכל ספר (₪)',
  adminDefaultPricePlaceholder: 'לדוגמה 200',
  adminTestSeries: 'סדרת בדיקה (לא נספרת בסטטיסטיקה)',
  adminNext: 'הבא',
  adminChildrenOptionalTitle: 'ילדים (אופציונלי)',
  adminChildrenPrefillHelp: 'ניתן למלא שמות עכשיו או אחר כך. תמונות, מחירים ויצירה מתבצעים בדף ניהול הסדרה לאחר היצירה.',
  adminChildNameOptional: 'שם ילד/ה (אופציונלי)',
  adminBack: 'חזרה',
  adminCreateSeriesAndManage: 'יצירת הסדרה וניהולה',
  adminCreatingSeries: 'יוצר…',
  adminBaseStoryNotSet: 'לא נבחר סיפור בסיס',

  // Footer
  footerText: 'אני גיבור — סיפורים אישיים לילדכם',
  footerTagline: 'כותבים ומציירים לילדכם סיפור שבו הוא הגיבור.',
  footerExploreTitle: 'גלו',
  footerHowItWorks: 'איך זה עובד?',
  footerTherapeutic: 'גישה טיפולית',
  footerBlog: 'בלוג',
  footerTerms: 'תנאי שימוש',
  footerContactTitle: 'יצירת קשר',
  footerWhatsApp: 'וואטסאפ',
  footerRights: 'כל הזכויות שמורות',

  // How it works page
  howItWorksTitle: 'מה קורה אחרי ההזמנה?',
  howItWorksLede: 'ברגע שההזמנה מושלמת, מתחיל מסע קצר שבו אנחנו דואגים לכל פרט — מהשלמת האיורים, דרך בדיקה משותפת, ועד שיכלול ומסירה. הנה כל שלב בפירוט.',
  howItWorksStep1Title: 'הזמנה ותשלום',
  howItWorksStep1Text: 'בוחרים סיפור ומשלימים תשלום מאובטח. מקבלים אישור מיידי וההזמנה מופיעה בחשבון.',
  howItWorksStep2Title: 'ציור שאר הסצנות',
  howItWorksStep2Text: 'לאחר התשלום מציירים את שאר סצנות הסיפור באותו סגנון. בדרך כלל תוך דקות ספורות.',
  howItWorksStep3Title: 'בדיקה ועריכה',
  howItWorksStep3Text: 'עוברים על הסיפור המלא ואפשר לבקש עריכות בטקסט או באיורים. בנוסף, הצוות שלנו בודק את השפה ומשפר את האיורים.',
  howItWorksStep4Title: 'השאר עלינו',
  howItWorksStep4Text: 'שילמתם ונתתם בנו אמון — אנחנו דואגים לשכלל את הסיפור עד הפרט האחרון ולהכין אותו לדפוס ומשלוח.',
  howItWorksStep5Title: 'הכנה ומשלוח',
  howItWorksStep5Text: 'לאחר הבדיקה מכינים את העותק ומוסרים לכם:',
  howItWorksDeliveryDigital: 'עותק דיגיטלי (PDF)',
  howItWorksDeliveryDigitalTime: 'מיד לאחר הבדיקה',
  howItWorksDeliveryPrint: 'עותק מודפס',
  howItWorksDeliveryPrintTime: '10 עד 14 ימי עסקים (בתוך הארץ)',
  howItWorksStep6Title: 'מעקב אחר סטטוס ההזמנה',
  howItWorksStep6Text: 'ניתן לעקוב אחר סטטוס ההזמנה בכל עת מעמוד «הסיפורים שלי» בחשבון. ההזמנה עוברת דרך השלבים הבאים:',
  howItWorksStatusCta: 'לסיפורים שלי',
  howItWorksHelpTitle: 'יש לך שאלה?',
  howItWorksHelpText: 'אנחנו כאן בכל שלב. צרו קשר דרך וואטסאפ או דוא"ל ונחזור אליכם במהירות.',

  // StoryLoader
  storyLoaderTitle: 'יוצרים את הסיפור של ילדכם ✨',
  storyLoaderSubtitle: 'עוד דקות ספורות והסיפור מוכן — אל תסגרו עמוד זה',

  // Header
  menuToggle: 'תפריט',

  // PromoBanner
  promoAriaLabel: 'מבצע',
  promoEyebrow: 'מבצע לזמן מוגבל',
  promoHeadline: '{books} סיפורים אישיים במחיר מיוחד',
  promoBundleDual: 'שני ספרים',
  promoBundlePlural: '{n} ספרים',
  promoCta: 'התחילו את הסיפור ←',

  // Book dedication / back-cover
  dedicationTitleGirl: 'לגיבורה הקטנה שלנו',
  dedicationTitleBoy: 'לגיבור הקטן שלנו',
  dedicationTitleNameGirl: 'ל{name}, הגיבורה שלנו',
  dedicationTitleNameBoy: 'ל{name}, הגיבור שלנו',
  summaryNameGirl: 'בסיפור הזה {name} יוצאת להרפתקה מלאה חום ודמיון, מגלה את הכוח המיוחד שלה ולומדת שהאומץ גדל איתה צעד אחר צעד.\nסיפור שנכתב ואויר במיוחד בשבילה — כי היא הגיבורה.',
  summaryNameBoy: 'בסיפור הזה {name} יוצא להרפתקה מלאה חום ודמיון, מגלה את הכוח המיוחד שלו ולומד שהאומץ גדל איתו צעד אחר צעד.\nסיפור שנכתב ואויר במיוחד בשבילו — כי הוא הגיבור.',
  summaryNoNameGirl: 'בסיפור הזה הגיבורה הקטנה שלנו יוצאת להרפתקה מלאה חום ודמיון, מגלה את הכוח המיוחד שלה ולומדת שהאומץ גדל איתה צעד אחר צעד.\nסיפור שנכתב ואויר במיוחד בשבילה.',
  summaryNoNameBoy: 'בסיפור הזה הגיבור הקטן שלנו יוצא להרפתקה מלאה חום ודמיון, מגלה את הכוח המיוחד שלו ולומד שהאומץ גדל איתו צעד אחר צעד.\nסיפור שנכתב ואויר במיוחד בשבילו.',
  dedicationTextGirl: 'הסיפור הזה נכתב ואויר במיוחד בשבילך, ואין עותק נוסף ממנו בכל העולם.\nשמרי עליו היטב, וכל פעם שתגדלי ותחזרי לדפים שלו, זכרי שהאומץ לא הגיע מהסיפור — הוא היה בך מההתחלה.\nהיי תמיד גיבורת הסיפור שלך.',
  dedicationTextBoy: 'הסיפור הזה נכתב ואויר במיוחד בשבילך, ואין עותק נוסף ממנו בכל העולם.\nשמור עליו היטב, וכל פעם שתגדל ותחזור לדפים שלו, זכור שהאומץ לא הגיע מהסיפור — הוא היה בך מההתחלה.\nהיה תמיד גיבור הסיפור שלך.',
  madeWithLoveIn: 'נוצר באהבה ב-{year}',

  // Top promo bar (site-wide announcement strip)
  topBarAria: 'קופון ההנחה הופעל',
  topBarReason: 'קופון ההנחה הופעל',
  topBarSave: 'חסכו {amount}₪',
  topBarCta: 'התחילו את הסיפור',

  // Graduation series banner
  gradBannerBadge: 'חדש — מיוחד לגני ילדים',
  gradBannerTitle: '🎓 סדרת סיום גן',
  gradBannerText: 'סיפור אחד לכל הכיתה — כל ילד/ה מקבל/ת עותק אישי בשמו ובתמונתו, וכל החברים חלק מהסיפור.',
  gradBannerPriceUnit: 'לספר בכריכה קשה',
  gradBannerSave: 'חסכו {amount}₪ לכל ספר',
  gradBannerCta: 'הזמינו עכשיו ←',
  gradModalClose: 'סגור',
  gradModalTitle: 'הזמנת סדרת סיום גן 🎓',
  gradModalText: 'סיפור אחד לכל הכיתה — כל ילד/ה מקבל/ת עותק אישי משלו. מלאו את הפרטים ונשלים את ההזמנה בוואטסאפ.',
  gradModalCountLabel: 'כמה ספרים צריך?',
  gradModalCountPlaceholder: 'מינימום 10 ספרים — לדוגמה: 25',
  gradModalCountHelper: 'מינימום 10 ספרים למחיר הסדרה (200₪ לספר).',
  gradModalDeadlineLabel: 'מה התאריך האחרון לאספקה?',
  gradModalPriceRow: 'מחיר הסדרה',
  gradModalPricePerBook: 'לכל ספר בכריכה קשה — להזמנות של',
  gradModalPriceMinBooks: '10 ספרים',
  gradModalPriceOrMore: 'ומעלה',
  gradModalTotal: 'סה"כ ({n} ספרים):',
  gradModalSavings: 'חיסכון של {amount}₪',
  gradModalBelowMin: 'הכמות נמוכה מהמינימום (10 ספרים). מחיר 200₪ חל על הזמנות מ-10 ספרים ומעלה — השלימו את ההזמנה וניצור קשר לתיאום.',
  gradModalHint: 'ככל שמזמינים יותר ספרים, כך החיסכון גדל — כיתה של {count} ספרים חוסכת {amount}₪.',
  gradModalSubmit: 'המשך בוואטסאפ',
  gradWhatsAppLine1: 'שלום, אני מעוניין/ת להזמין סדרת סיום גן.',
  gradWhatsAppLine2: 'סיפור אחד לכל הכיתה — כל ילד/ה מקבל/ת עותק אישי בשמו ובתמונתו.',
  gradWhatsAppCount: 'מספר ספרים: {n}',
  gradWhatsAppDeadline: 'תאריך אחרון לאספקה: {deadline}',
  gradWhatsAppBelowMin: 'הערה: הכמות נמוכה מ-10 ספרים — אשמח לפרטים ומחיר מתאים.',
  gradTrackName: 'סדרת סיום גן',

  // Home page
  heroSocialReview: 'בדיקת איכות לכל סיפור',
  heroSocialFormats: 'דיגיטלי או מודפס',
  heroFeatureMore: 'קראו עוד ←',
  categoryBadgeTherapy: 'גישה טיפולית',
  promoBadgeNew: 'חדש — סיפור העונה',
  promoStartCta: 'התחילו את סיפור ילדכם ←',
  reviewsSectionTitle: 'מה אמרו ההורים',
  waProofTitle: 'הודעות אמיתיות מהורים',
  waProofSubtitle: 'צילומי מסך אמיתיים מהשיחות שלנו בוואטסאפ (טשטשנו את המספרים לפרטיות)',
  waProofView: 'לחצו להגדלה',
  waProofAlt: 'הודעת וואטסאפ מהורה',
  seTitle: 'הורים שניסו לפניכם',
  seLede: 'סרטונים והודעות אמיתיים מהורים שהזמינו סיפור לילדים שלהם — בלי שום עריכה.',
  seVideosTitle: 'סרטונים מהורים',
  seCta: 'התחילו את סיפור ילדכם ←',
  categoryCoverTherapy: 'נועה והכלב האמיץ',
  categoryCoverHeroes: 'מיכל גיבורת-העל',
  categoryCoverBirthday: 'איתי בחלל',
  categoryCoverMilestones: 'יובל הולך לגן',

  // Preview page
  previewGoToOrder: 'מעבר להזמנה',
  trustPaymentSecure: 'תשלום מאובטח דרך Stripe',
  trustRatingOf: 'מתוך',
  trustRatingReview: 'ביקורות',

  // Checkout page
  adminFreeNotice: 'יצירה חינמית לצוות — לא ייגבה תשלום.',
  adminFreeBtn: 'יצירה חינמית',
  checkoutTrustSsl: 'חיבור מוצפן SSL',
  checkoutTrustStripe: 'תשלום מאובטח דרך Stripe',
  checkoutDeliveryEstimate: 'ההדפסה והמשלוח אורכים 10 עד 14 ימי עסקים בתוך הארץ.',

  // Cart page
  cartChildPrefix: 'עבור ',
  cartStoryFallback: 'סיפור',

  // Account page
  statusCancelled: 'בוטל',
  accountNameLabel: 'שם',
  accountNoOrders: 'אין הזמנות עדיין',

  // Register page
  registerNameLabel: 'שם',

  // Order detail page
  orderRequestNoDetails: 'אין פרטים.',
  orderRequestFieldName: 'שם הילד/ה',
  orderRequestFieldAge: 'גיל',
  orderRequestFieldGender: 'מין',
  orderRequestFieldIssue: 'האתגר / הבעיה',
  orderRequestFieldCustomFear: 'הפחד הספציפי',
  orderRequestFieldWhenHappens: 'מתי זה קורה',
  orderRequestFieldHowBehaves: 'איך מתנהג/ת',
  orderRequestFieldSmallGoal: 'המטרה הקטנה',
  orderRequestFieldFamilyStructure: 'מבנה המשפחה',
  orderRequestFieldPersonalityTraits: 'תכונות אישיות',
  orderRequestFieldInterests: 'תחומי עניין',
  orderRequestFieldEnvironment: 'סביבה / מקום',
  orderRequestFieldStoryLanguage: 'שפת הסיפור',
  orderRequestFieldImageStyle: 'סגנון האיורים',
  orderRequestFieldDialect: 'ניב',
  orderRequestFieldVariantSku: 'מוצר',
  orderUploadedImages: 'תמונות שהועלו',
  orderChildPhoto: 'תמונת הילד/ה',
  orderReferenceImage: 'הפניה',
  orderAdminToolsTag: 'כלי מנהל',
  orderAdminEditScenes: 'עריכת סצנות',
  orderAdminPdfBusy: 'מכין PDF…',
  orderAdminPdfCover: 'PDF כריכה',
  orderAdminPdfPages: 'PDF תוכן (עמוד עמוד)',
  orderAdminBarcodeLabel: 'ברקוד',
  orderAdminAssigningBarcode: 'מקצה…',
  orderAdminAssignBarcode: 'הקצה ברקוד',
  orderAdminRequestTitle: 'פרטי ההזמנה שהוזנו',
  orderAdminRequestHint: 'הצגת כל מה שהלקוח הזין בטופס, כולל התמונות שהועלו.',
  orderAdminRequestLoading: 'טוען…',
  orderAdminRequestBtn: 'הצג פרטי הזמנה',
  orderPrintPdfError: 'יצירת PDF לדפוס נכשלה: ',
  orderPrintPdfErrorUnknown: 'שגיאה לא ידועה',
  orderBarcodeError: 'יצירת ברקוד נכשלה: ',

  // TemplateDetail page
  templateReviewCount: 'ביקורות',

  // Terms page
  termsPageTitle: 'תנאי שימוש ומדיניות פרטיות',
  termsLastUpdated: 'עדכון אחרון',
  termsSection1Title: '1. מבוא וקבלת התנאים',
  termsSection1P1: 'ברוכים הבאים ל«{tradeName}» (המכונה במסמך זה «הפלטפורמה» או «השירות»), שם מסחרי המופעל על ידי {legalName} הרשומה בישראל. הפלטפורמה מאפשרת יצירת סיפורי ילדים מותאמים אישית ומאוירים באמצעות בינה מלאכותית, בפורמט דיגיטלי ו/או מודפס.',
  termsSection1P2: 'בשימוש בפלטפורמה, ביצירת חשבון או בביצוע הזמנה, הנך מאשר/ת שקראת תנאים אלה ומדיניות הפרטיות, מסכים/ה להם ומתחייב/ת לפעול על פיהם. אם אינך מסכים/ה לתנאים, נא להימנע משימוש בפלטפורמה.',
  termsSection2Title: '2. הגדרות',
  termsSection2Items: [
    '«הפלטפורמה» / «השירות»: אתר «{tradeName}» והשירותים והיישומים הקשורים אליו.',
    '«המשתמש/ת» / «את/ה»: כל אדם המשתמש בפלטפורמה, יוצר חשבון או מבצע הזמנה.',
    '«האפוטרופוס»: ההורה או האפוטרופוס החוקי של הילד/ה שהסיפור נוצר עבורו.',
    '«התוכן המועלה»: תמונות, שמות, מידע ופרטים שהמשתמש/ת מזין/ה ליצירת הסיפור.',
    '«הסיפור»: היצירה הטקסטואלית והמאוירת שהפלטפורמה יוצרת על בסיס התוכן המועלה.',
  ],
  termsSection3Title: '3. תיאור השירות',
  termsSection3P1: 'הפלטפורמה יוצרת סיפורים מותאמים אישית (טיפוליים-תומכים, דמיוניים או הרפתקאות) שבהם הילד/ה הוא הדמות המרכזית, עם איורים שנוצרים בבינה מלאכותית על בסיס המידע והתמונות שהמשתמש/ת מספק/ת. הסיפור זמין בפורמט דיגיטלי (PDF) ו/או כספר מודפס שנשלח לכתובת שהמשתמש/ת מציין/ה.',
  termsSection3P2: 'אנו שואפים לתוצאות באיכות גבוהה, אך תוכן שנוצר בבינה מלאכותית עלול לכלול שונות או שגיאות; לכן ניתנת למשתמש/ת אפשרות לבדוק ולאשר את הסיפור לפני שליחתו לדפוס.',
  termsSection4Title: '4. כשירות ושימוש של מבוגרים בשם ילדים',
  termsSection4Items: [
    'יוצר/ת החשבון ומבצע/ת ההזמנה חייב/ת להיות בגיר/ה (מעל גיל 18) בעל/ת כשרות משפטית מלאה.',
    'הפלטפורמה אינה מיועדת לילדים, ואין לילדים ליצור חשבונות, לבצע הזמנות או להעלות תוכן בעצמם.',
    'סיפורים הנוגעים לילדים נוצרים אך ורק על ידי ההורה או האפוטרופוס החוקי, או על ידי מבוגר שקיבל הרשאה מפורשת מהאפוטרופוס.',
  ],
  termsSection5Title: '5. תמונות ילדים והתוכן שאת/ה מעלה',
  termsSection5Intro: 'סעיף זה מהותי מכיוון ששירותנו מסתמך על תמונות שהורים מעלים של ילדיהם. נא לקרוא בעיון:',
  termsSection5Items: [
    'הרשאה: מותר לך להעלות תמונת ילד/ה רק אם את/ה הורה או אפוטרופוס חוקי שלו/ה, או אם קיבלת הרשאה מפורשת ומוקדמת מהאפוטרופוס החוקי.',
    'הצהרה ואחריות: בהעלאת תמונה או תוכן, הנך מצהיר/ה ומתחייב/ת שיש לך את מלוא הזכויות וההרשאות הנדרשות להעלאתו ולשימוש בו כמתואר בתנאים אלה.',
    'מטרה בלעדית: אנו משתמשים בתמונות הילד/ה ובמידע המצורף אך ורק ליצירת איורי הסיפור של אותו ילד/ה, ולא לכל מטרה אחרת.',
    'ללא אימון מודלים: איננו משתמשים בתמונות ילדים או בתוכן שלך לאימון מודלים של בינה מלאכותית.',
    'ללא מכירה או שיווק: איננו מוכרים תמונות ילדים ואיננו משתפים אותן עם צד שלישי למטרות שיווקיות או פרסומיות.',
    'עיבוד בבינה מלאכותית: ליצירת האיורים, התמונות והמידע עשויים להישלח לספקי שירותי בינה מלאכותית חיצוניים מהימנים, אך ורק לצורך הפקת הסיפור שלך ובכפוף להסכמים המגבילים את השימוש בנתונים למטרה זו.',
    'מחיקה ממאגרי הנתונים שלנו: לאחר השלמת יצירת הסיפור ומסירת ההזמנה, אנו מוחקים את תמונות הילדים המקוריות שהועלו ממאגרי הנתונים שלנו תוך 90 יום לכל היותר. ניתן לבקש מחיקה מיידית בכל עת באמצעות יצירת קשר.',
    'הסיפור הסופי: האיורים שנוצרו ומרכיבים את הסיפור שלך נשמרים כחלק מההזמנה והמוצר, אך תמונות הילד/ה המקוריות נמחקות כאמור לעיל.',
  ],
  termsSection6Title: '6. אופי טיפולי של התוכן וויתור על אחריות רפואית',
  termsSection6Items: [
    'הסיפורים המתוארים כ«טיפוליים» הם סיפורים תומכים וחינוכיים שמטרתם לסייע לילד/ה לבטא רגשות ולהתמודד עם אתגרים בדרך עדינה.',
    'סיפורים אלה אינם אבחון ואינם טיפול רפואי או פסיכולוגי, ואינם תחליף להתייעצות עם רופא/ה או מטפל/ת מוסמך/ת.',
    'אם ילדכם סובל ממצוקה נפשית או התנהגותית חמורה, נא לפנות לאיש/אשת מקצוע. הפלטפורמה אינה נושאת באחריות להחלטות המתקבלות על סמך תוכן הסיפורים.',
  ],
  termsSection7Title: '7. קניין רוחני ורישיון',
  termsSection7Items: [
    'כל הזכויות בפלטפורמה, בעיצוביה, בתבניותיה, בסגנונה האמנותי ובתוכנותיה שייכות לנו או לנותני הרישיון שלנו.',
    'בהשלמת התשלום, הפלטפורמה מעניקה לך רישיון אישי, לא בלעדי ולא ניתן להעברה, לשימוש בסיפור שנוצר למטרות אישיות ומשפחתיות שאינן מסחריות.',
    'אין למכור מחדש את הסיפור, להשתמש בו מסחרית או להפיצו בהיקף רחב ללא אישור בכתב מאיתנו.',
    'הנך מעניק/ה לנו, במידה הנדרשת למתן השירות, רישיון מוגבל לעבד את התוכן שהעלית ליצירת הסיפור שלך.',
  ],
  termsSection8Title: '8. מחירים ותשלום',
  termsSection8Items: [
    'המחירים מוצגים בשקלים חדשים (₪), ובעת התשלום מצוין אם הם כוללים מסים.',
    'התשלומים מבוצעים דרך ספקי שירותי תשלום חיצוניים, ואיננו שומרים את פרטי כרטיס האשראי המלאים שלך בשרתים שלנו.',
    'אנו שומרים את הזכות לעדכן מחירים בכל עת, מבלי שהדבר ישפיע על הזמנות שאושרו קודם לכן.',
  ],
  termsSection9Title: '9. הזמנות, הפקה ומשלוח',
  termsSection9Items: [
    'לאחר התשלום ואישור הסיפור, אנו מתחילים בהפקתו (ובהדפסתו אם ההזמנה היא לעותק מודפס).',
    'עותקים מודפסים נשלחים לכתובת שסיפקת בתוך ישראל; באחריותך לוודא שפרטי הכתובת מדויקים.',
    'זמני ההפקה והמשלוח עשויים להשתנות; אנו עושים מאמץ סביר לעמוד בלוחות הזמנים שפורסמו.',
  ],
  termsSection11Title: '11. שימוש מותר ותוכן אסור',
  termsSection11Items: [
    'חל איסור להעלות תמונות או תוכן שאין לך זכויות או הרשאה להעלותו.',
    'חל איסור להעלות תמונות ילדים שאינך הורה או אפוטרופוס שלהם, וללא הרשאה מפורשת מהאפוטרופוס.',
    'חל איסור להעלות תוכן בלתי חוקי, פוגעני, מסית לשנאה או הפוגע בזכויות אחרים.',
    'אנו שומרים את הזכות לסרב או להסיר כל תוכן מפר ולהשעות חשבונות מפרים.',
  ],
  termsSection12Title: '12. פרטיות והגנה על נתונים',
  termsSection12Intro: 'אנו מחויבים להגן על פרטיותך ולעבד את הנתונים שלך בהתאם לחוק הגנת הפרטיות הישראלי משנת 1981 (חוק הגנת הפרטיות) ולתקנות מכוחו.',
  termsSection12Items: [
    'נתונים שאנו אוספים: פרטי חשבון (שם, דוא"ל, מספר טלפון), פרטי הזמנה וכתובת למשלוח, מידע שמוזן ליצירת הסיפור (כולל שם הילד/ה, גיל, תמונות והפרטים שמסרת), ונתוני תשלום שמעובדים על ידי ספק התשלום.',
    'מטרות עיבוד: מתן השירות ויצירת הסיפור, עיבוד הזמנות ותשלומים ומשלוח, תקשורת בנוגע להזמנתך, ועמידה בחובות משפטיות.',
    'שיתוף נתונים: אנו משתפים רק את הנדרש עם ספקי שירותי בינה מלאכותית (ליצירת איורים), ספקי תשלום, חברות שילוח וספקי אחסון, אך ורק למתן השירות.',
    'העברה מחוץ לישראל: חלק מהנתונים עשויים להיות מעובדים אצל ספקי שירות מחוץ לישראל; אנו נוקטים צעדים סבירים להגנה על הנתונים בעת ההעברה.',
    'שמירה ומחיקה: אנו שומרים את הנתונים למשך הזמן הנדרש למתן השירות ולעמידה בחובות משפטיות וחשבונאיות. תמונות ילדים מקוריות נמחקות כאמור בסעיף תמונות הילדים לעיל.',
    'אבטחה: אנו נוקטים אמצעים טכניים וארגוניים סבירים להגנה על הנתונים שלך מפני גישה או שימוש בלתי מורשים.',
    'זכויותיך: באפשרותך לעיין בנתונים האישיים שלך, לתקנם ולבקש מחיקתם באמצעות פנייה אלינו בדוא"ל המפורט להלן.',
  ],
  termsSection13Title: '13. עוגיות (Cookies)',
  termsSection13P1: 'אנו משתמשים בעוגיות ובטכנולוגיות דומות להפעלת הפלטפורמה, לשיפור חוויית השימוש ולניתוח השימוש. ניתן לנהל אותן דרך הגדרות הדפדפן.',
  termsSection14Title: '14. ויתור על אחריות',
  termsSection14P1: 'השירות מסופק "כמות שהוא" ו"לפי זמינות" ללא אחריות מפורשת או משתמעת מעבר למה שהחוק החל מחייב.',
  termsSection15Title: '15. הגבלת אחריות',
  termsSection15P1: 'ככל שהחוק מאפשר, אחריותנו הכוללת כלפיך לא תעלה על הסכום ששילמת בפועל עבור ההזמנה שבמחלוקת, ואיננו נושאים בנזקים עקיפים או תוצאתיים.',
  termsSection16Title: '16. שיפוי',
  termsSection16P1: 'הנך מסכים/ה לשפות אותנו בגין כל תביעה או נזק הנובעים מהפרת תנאים אלה מצדך, או מהעלאת תוכן או תמונות ללא הזכויות או ההרשאות הנדרשות (בפרט תמונות ילדים ללא הרשאת האפוטרופוס החוקי).',
  termsSection17Title: '17. שינוי התנאים',
  termsSection17P1: 'אנו רשאים לעדכן תנאים אלה מעת לעת. הגרסה המעודכנת תפורסם בעמוד זה עם עדכון תאריך «העדכון האחרון», והמשך השימוש בפלטפורמה לאחר מכן ייחשב כהסכמה לגרסה המעודכנת.',
  termsSection18Title: '18. הדין החל וסמכות שיפוט',
  termsSection18P1: 'תנאים אלה כפופים לחוקי מדינת ישראל ויפורשו בהתאם להם, ולבתי המשפט המוסמכים ב{jurisdictionCity}, ישראל, סמכות שיפוט ייחודית בכל סכסוך הנובע מהם.',
  termsSection19Title: '19. יצירת קשר',
  termsSection19Intro: 'לכל שאלה, או לבקשת עיון, תיקון או מחיקת נתונים, נא לפנות אלינו באמצעות:',
  termsContactEmail: 'דוא"ל',
  termsContactWhatsApp: 'וואטסאפ',

  // Therapeutic approach page
  therapeuticPageTitle: 'הגישה הטיפולית: איך אנחנו עוזרים לילדכם להתמודד עם אתגרים',
  therapeuticLede: 'ב«אני גיבור» אנחנו מאמינים שסיפור הוא לא רק בידור, אלא כלי עדין שעוזר לילד/ה להבין את רגשותיו ולהתמודד עם פחדים. בכתיבת הסיפורים שלנו אנחנו מסתמכים על עקרונות «ביבליותרפיה» (טיפול בקריאה), שיטה שמחנכים ומטפלים משתמשים בה כבר עשרות שנים כדי לעזור לילדים להתגבר על אתגרים דרך דמות שהם אוהבים ומזדהים איתה.',
  therapeuticPrinciplesTitle: 'כל סיפור מותאם לגיל ולמטרה של ילדכם',
  therapeuticPrinciplesIntro: 'לכל ילד/ה הגיל שלו, ולכל אתגר המטרה שלו. לכן אנחנו לא כותבים סיפור אחד שמתאים לכולם, אלא מעצבים כל סיפור סביב ארבעה עקרונות:',
  therapeuticPillar1Title: 'גיל ילדכם',
  therapeuticPillar1Text: 'אנחנו בוחרים את השפה, הסצנות והקצב כך שיתאימו לשלב ההתפתחותי של ילדכם — מה שמרגיע בגיל שלוש שונה ממה שמעורר השראה בגיל תשע.',
  therapeuticPillar2Title: 'מטרת הסיפור',
  therapeuticPillar2Text: 'אנחנו יוצאים מצעד קטן ומציאותי שהייתם רוצים עבור ילדכם — לישון לבד, או להיפרד בלי בכי — בלי הטפה ובלי נזיפה.',
  therapeuticPillar3Title: 'הזדהות',
  therapeuticPillar3Text: 'ילדכם הוא גיבור הסיפור, רואה את עצמו בתוכו וחווה את הפתרון עם הדמות צעד אחר צעד.',
  therapeuticPillar4Title: 'סיום בטוח',
  therapeuticPillar4Text: 'כל סיפור מסתיים בתקווה ובביטחון — ילדכם סוגר את הספר כשהוא מרגיש בטוח ומסוגל.',
  therapeuticPrinciplesNote: 'עקרונות אלה מבוססים על ספרות מחקרית בנושא ביבליותרפיה, מחקר בפסיכולוגיה התפתחותית של ילדים, וגישות חינוכיות מבוססות ראיות להתאמת תוכן לכל שלב גיל. הדרך שבה אנחנו מתרגמים עקרונות אלה לסיפור ספציפי היא סוד המתודולוגיה שלנו — מה שחשוב לכם הוא שהתוצאה היא סיפור שעוצב במיוחד לילדכם, לגילו, לשמו ולאתגר שלו.',
  therapeuticScienceTitle: 'למה סיפורים עוזרים? מה אומר המדע',
  therapeuticScienceIntro: 'כשילד/ה קורא/ת סיפור קרוב למצב שלו, שלושה תהליכים חשובים מתרחשים — כפי שמתארים מומחי ביבליותרפיה:',
  therapeuticScienceIdentification: 'הזדהות: הילד/ה מוצא/ת את עצמו/ה בגיבור ומרגיש/ה שהוא/היא לא לבד במה שעובר עליו/ה.',
  therapeuticScienceCatharsis: 'קתרזיס: מבטא/ת רגשות מודחקים דרך עלילת הסיפור, במרחב בטוח.',
  therapeuticScienceInsight: 'תובנה: מגלה/ה דרך להתמודד עם הבעיה בלי להרגיש מולקח/ת או מוכח/ת.',
  therapeuticScienceSourcesIntro: 'עקרונות אלה אינם דעה אלא נושא למאמרים ומחקרים חינוכיים ופסיכולוגיים. הנה מקורות שניתן לקרוא למידע נוסף:',
  therapeuticResearch1Title: 'ביבליותרפיה (Bibliotherapy)',
  therapeuticResearch1Source: 'ויקיפדיה',
  therapeuticResearch1Summary: 'מבוא לביבליותרפיה כשימוש בחומרי קריאה נבחרים ככלי טיפולי, עם סקירת ההיסטוריה, הסוגים והיישומים הפסיכולוגיים.',
  therapeuticResearch2Title: 'חיזוק רגשי דרך סיפור',
  therapeuticResearch2Source: 'אקדמיית אלקאסמי',
  therapeuticResearch2Summary: 'תוכנית אקדמית שמכשירה מחנכים להשתמש בסיפור ככלי טיפולי שעוזר לילדים לבטא רגשות.',
  therapeuticResearch3Title: 'הסיפור הטיפולי ושלבי ההחלמה',
  therapeuticResearch3Source: 'טיפול בסיפור',
  therapeuticResearch3Summary: 'הסבר על מרכיבי הסיפור הטיפולי, מטרותיו וארבעת שלביו: אמפתיה, התבוננות, קתרזיס ומודעות.',
  therapeuticResearch4Title: 'ביבליותרפיה — טיפול בקריאה',
  therapeuticResearch4Source: 'ארט תרפי — כווית',
  therapeuticResearch4Summary: 'מאמר המסביר ביבליותרפיה מודרכת ואת השפעתה הרגשית, עם סקירה היסטורית על מקורותיה ושימושיה.',
  therapeuticDisclaimer: 'הסיפורים הטיפוליים שלנו הם סיפורים תומכים וחינוכיים שעוזרים לילדכם לבטא רגשות ולהתמודד עם אתגרים בעדינות. אך הם אינם אבחון ואינם טיפול רפואי או פסיכולוגי, ואינם תחליף להתייעצות עם רופא/ה או מטפל/ת מוסמך/ת בעת הצורך.',
  therapeuticCtaTitle: 'סיפורים טיפוליים מוכנים לילדכם',
  therapeuticCtaIntro: 'הנה כמה מהסיפורים הטיפוליים שלנו — בחרו את האתגר הקרוב ביותר לילדכם והתחילו ליצור:',
  therapeuticCtaBtn: 'לכל הסיפורים הטיפוליים',

  // Admin Stats page
  adminBannerGradSeries: 'באנר סדרת סיום גן',
  adminBannerPromo: 'באנר מבצע',
  adminRangeToday: 'היום',
  adminRange7Days: '7 ימים',
  adminRange30Days: '30 יום',
  adminRange90Days: '90 יום',
  adminRangeAll: 'כל הזמן',
  adminRangeCustom: 'מותאם',
  adminExpenseAds: 'פרסום',
  adminExpenseAi: 'בינה מלאכותית',
  adminExpensePrinting: 'הדפסה',
  adminExpenseDelivery: 'משלוח',
  adminExpenseOther: 'אחר',
  adminFrom: 'מ',
  adminTo: 'עד',
  adminSelectDateRange: 'בחר/י תאריך התחלה וסיום',
  adminConversionFunnel: 'משפך המרה',
  adminVisitors: 'מבקרים',
  adminPreviews: 'תצוגות מקדימות',
  adminPurchases: 'רכישות',
  adminOverallConversion: 'המרה כוללת ממבקר לרכישה:',
  adminBannerClicks: 'קליקים על באנרים:',
  adminUniqueVisitor: 'מבקר ייחודי',
  adminOfVisitors: 'מהמבקרים',
  adminVisitor: 'מבקר',
  adminFinancialPerformance: 'ביצועים פיננסיים',
  adminRevenueLabel: 'הכנסות',
  adminCogsCost: 'עלות מוצרים (הדפסה+משלוח+AI)',
  adminExpensesAds: 'הוצאות (פרסום…)',
  adminNetProfit: 'רווח נקי',
  adminProfitMargin: 'שולי רווח',
  adminAiSpendActual: 'הוצאת AI בפועל (לעיון)',
  adminDailyIncomeSpend: 'הכנסות והוצאות יומיות',
  adminDayTooltipIncome: 'הכנסה',
  adminDayTooltipSpend: 'הוצאה',
  adminDayTooltipProfit: 'רווח',
  adminLegendIncome: 'הכנסה',
  adminLegendSpend: 'הוצאה',
  adminCostRates: 'תעריפי עלות',
  adminBookPrinting: 'הדפסת ספר (₪)',
  adminDeliveryCost: 'משלוח (₪)',
  adminExchangeRate: 'שער דולר',
  adminSaveRates: 'שמור תעריפים',
  adminSaved: 'נשמר',
  adminAiCostNote: 'עלות ה-AI מחושבת מההוצאה בפועל לכל סיפור (בדולרים) כפול שער החליפין.',
  adminExpenses: 'הוצאות',
  adminDescription: 'תיאור',
  adminDescriptionPlaceholder: 'לדוגמה: קמפיין פייסבוק ספטמבר',
  adminType: 'סוג',
  adminAmount: 'סכום (₪)',
  adminPeriod: 'תקופה',
  adminPeriodSpread: 'תקופה (מתחלק יומי)',
  adminOneTime: 'חד פעמי',
  adminDate: 'תאריך',
  adminAdd: 'הוסף',
  adminAmountCol: 'סכום',
  adminNoExpensesYet: 'אין הוצאות עדיין',
  adminEmailTracking: 'מעקב אימיילים',
  adminEmailTypeOrderConfirmation: 'אישור הזמנה',
  adminEmailTypeStoryReady: 'הסיפור מוכן',
  adminEmailTypeStoryPdf: 'מסירת PDF',
  adminEmailTypeBookReady: 'הספר מוכן',
  adminEmailTypeTeaser: 'תזכורת תצוגה מקדימה',
  adminEmailTypeStoryFinalize: 'סקירה ואישור',
  adminEmailTypeAccountCreated: 'חשבון חדש',
  adminEmailTypeMagicLogin: 'קישור כניסה',
  adminEmailTypePasswordReset: 'איפוס סיסמה',
  adminEmailTypePaymentNotice: 'הודעת תשלום (פנימי)',
  adminEmailTypeUnknown: 'אחר',
  adminEmailFilterAll: 'הכל',
  adminEmailFilterOpened: 'נפתח',
  adminEmailFilterNotOpened: 'לא נפתח',
  adminStatus: 'סטטוס',
  adminEmailCount: 'אימייל',
  adminRecipient: 'נמען',
  adminSubject: 'נושא',
  adminSent: 'נשלח',
  adminOpenedQuestion: 'נפתח?',
  adminOpenTime: 'זמן פתיחה',
  adminOpenCount: 'פעמים',
  adminYes: 'כן',
  adminNo: 'לא',
  adminNoEmailsYet: 'אין אימיילים רשומים עדיין',
  adminTopViewedStories: 'הנצפים ביותר (סיפורים)',
  adminTopPreviewed: 'הנצפים מראש ביותר',
  adminTopViewedCategories: 'הנצפים ביותר (קטגוריות)',
  adminViewCount: 'צפייה',
  adminPreviewCount: 'תצוגה מקדימה',
  adminName: 'שם',
  adminNoDataYet: 'אין נתונים',
  adminDashboardLink: 'לוח בקרה',
  adminDeleteExpense: 'מחק',
  adminPaymentNoticeShort: 'הודעת תשלום',

  // Series Wizard
  adminCreateSeries: 'יצירת סדרה',
  adminFromStory: 'מהסיפור: ',
  adminStepStory: 'הסיפור',
  adminStepGraphics: 'האיורים',
  adminStepCount: 'הכמות',
  adminStepChildren: 'ילדים (אופציונלי)',
  adminStoryText: 'הסיפור (טקסט)',
  adminSameStory: 'אותו סיפור',
  adminSameStoryDesc: 'אותו טקסט בדיוק, עם החלפת שם והתאמת מגדר לכל ילד.',
  adminNewStoryPerChild: 'סיפור חדש לכל ילד',
  adminNewStoryPerChildDesc: 'אותה תבנית ורעיון, אבל ה-AI כותב טקסט חדש לכל ילד.',
  adminGraphicsLabel: 'איורים',
  adminSameGraphicsLabel: 'אותם איורים',
  adminSameGraphicsDesc: 'אותן תמונות בדיוק עם החלפת פני הילד — קיבוע תמונת המקור כהפניה ובקשה מהמודל לשחזר את אותה קומפוזיציה.',
  adminNewGraphics: 'איורים חדשים',
  adminNewGraphicsDesc: 'יצירת תמונות חדשות לכל ילד על סמך הטקסט, תוך שמירה על הסגנון.',
  adminWizardSettings: 'הגדרות',
  adminChildrenCount: 'מספר ילדים',
  adminSeriesTitleField: 'כותרת הסדרה',
  adminSeriesTitlePlaceholder: 'למשל: גן התקווה - כיתה א׳',
  adminDefaultPricePerBook: 'מחיר ברירת מחדל לספר (₪)',
  adminDefaultPricePlaceholder: 'למשל 200',
  adminTestSeries: 'סדרת ניסיון (לא נספרת בסטטיסטיקות)',
  adminChildrenOptionalTitle: 'ילדים (אופציונלי)',
  adminChildrenPrefillHelp: 'אפשר למלא שמות עכשיו או אחר כך. תמונות, מחירים ויצירה מתבצעים בעמוד ניהול הסדרה לאחר היצירה.',
  adminChildNameOptional: 'שם הילד (אופציונלי)',
  adminCreateSeriesAndManage: 'יצירת הסדרה וניהולה',
  adminCreatingSeries: 'יוצר…',
  adminBaseStoryNotSet: 'לא נבחר סיפור בסיס',
  adminLoadStoryError: 'לא ניתן לטעון את הסיפור',
  adminCreateSeriesError: 'לא ניתן ליצור את הסדרה',
  adminLoading: 'טוען…',

  // Language switcher
  langAr: 'عربي',
  langHe: 'עברית',

  // Pay-first experiment — admin settings
  adminPayFirstTitle: 'ניסוי תשלום מראש (A/B)',
  adminPayFirstHelp: 'כשמופעל, חלק מהמבקרים מנותבים למסלול "תשלום תחילה": הם מוסיפים ספרים לעגלה ומשלמים לפני יצירת התצוגה, ואז יוצרים את הסיפורים מהחשבון לאחר התשלום ומבקשים מאיתנו לשכלל אותם להדפסה. שאר המבקרים נשארים במסלול התצוגה החינמית.',
  adminPayFirstPercent: 'אחוז המבקרים במסלול תשלום מראש (%)',

  // Pay-first experiment — storefront add-to-cart
  payFirstAddToCart: 'הוסף לעגלה',
  payFirstAddAnother: 'הוסף עותק נוסף',
  payFirstAddedNote: 'נוסף לעגלה',
  payFirstAddedModalTitle: 'הספר נוסף לעגלה',
  payFirstCtaNote: 'קונים את הספר עכשיו — אחרי התשלום יוצרים את הסיפור עם השם והתמונה של ילדכם, ולא מדפיסים בלי אישורכם.',
  pfProofIgCaption: 'הורים מאושרים מעמוד האינסטגרם שלנו — חפשו אותנו בטלפון:',
  payFirstAddedModalSubtitle: 'הספר בעגלה לקנייה. שלמו עכשיו או הוסיפו ספרים נוספים — אחרי התשלום תיצרו את הסיפור עם השם והתמונה של ילדכם.',
  payFirstModalCheckout: 'לתשלום עכשיו',
  payFirstModalKeepShopping: 'הוספת ספרים נוספים',
  payFirstGoToCart: 'לעגלה',

  // Pay-first experiment — cart + checkout + success
  payFirstCartHint: 'שלמו על הספרים תחילה, ואז צרו את הסיפור של כל ספר מהחשבון ובקשו מאיתנו לשכלל אותו לפני ההדפסה.',
  payFirstDeliveryNote: 'דמי משלוח לספרים מודפסים יתווספו בתשלום.',
  payFirstReassurance: 'לאחר התשלום אתם יוצרים את הסיפורים שלכם בעצמכם, שלב אחר שלב מהחשבון, ואז הצוות שלנו עובר עליהם, משכלל אותם ומכין אותם להדפסה — ולא נדפיס עד לאישורכם את הגרסה הסופית.',
  payFirstPayAll: 'שלם על הכל',
  payFirstCheckoutHint: 'לאחר התשלום, צרו את הסיפור של כל ספר מהחשבון.',
  payFirstSuccessDesc: 'התשלום התקבל. עברו להזמנה כדי ליצור את הסיפורים שלכם עכשיו.',
  payFirstCreateNow: 'צור את הסיפורים שלי',

  // Pay-first experiment — order page + post-payment creation
  payFirstOrderCreateTitle: 'צרו את הסיפורים שלכם',
  payFirstOrderCreateHint: 'לכל ספר ששילמתם עליו, צרו את הסיפור עם פרטי הילד והתמונות, ואז בקשו מאיתנו לשכלל אותו לקראת הדפסה.',
  payFirstCreateStoryCta: 'צור את הסיפור שלך',
  payFirstStoryCreatedCta: 'הצג / ערוך את הסיפור',
  payFirstStoryGenerating: 'נוצר כעת…',
  payFirstOrderItemCreateTitle: 'צור את הסיפור שלך',
  payFirstOrderItemCreateSubtitle: 'שילמת על הספר הזה. הזן את פרטי הילד והתמונות כדי ליצור את הסיפור, ואז בקש מאיתנו לשכלל אותו לפני ההדפסה.',

  // Pay-first experiment — request edits
  requestEditsTitle: 'בקשו מאיתנו תיקונים לפני ההדפסה',
  requestEditsPlaceholder: 'כתבו את התיקונים שתרצו בסיפור או בתמונות…',
  requestEditsSubmit: 'בקש מאיתנו לתקן',
  requestEditsSending: 'שולח…',
  requestEditsSent: 'נשלח — נשכלל אותו ונשלח לך את הגרסה הסופית לאישור לפני ההדפסה.',
  requestEditsEmpty: 'אנא כתבו את התיקונים המבוקשים',
};

export default he;
